/* eslint-disable import/no-anonymous-default-export */
import styles from "./excel.module.scss";
import { Link, useHistory } from "react-router-dom";
import { pages } from "../../constants/PagePaths";
import React, { useRef, useState, useContext } from "react";
import { useTenant, ownerLabel } from "../../contexts/TenantContext";
import { Checkbox, Radio } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { ExcelX2File, ExcelX2FileSheet } from "../../models/excelModel/excelX2";
import { sumX2Eta, formatEtaKo, NON_STATEMENT_SHEET, adviseX2Split } from "../../utils/x2Eta";
import { ExcelItem } from "../../models/excelModel/excelItem";
import { PresetItem, PRESET_TYPES } from "../../models/PresetItem";
import PresetModal from "../../components/modal/PresetModal";
import {
  UsagePlanModel,
  UsagePlanItem,
} from "../../models/beginConstDoc/UsagePlanModel";
import moment from "moment";
import _ from "lodash";
import UsagePlanForm from "../../components/forms/UsagePlanForm";
import ScheduleForm from "../../components/forms/ScheduleForm";
import { util } from "../../config/util";
import AlertContext from "../../contexts/AlertContext";

interface Props {
  fileInfos: ExcelX2File[];
  fileCountLimit: number;
  originOption: string;
  coverOption: string;
  divideOption: string;
  divideDirection: string;
  originRowOption: boolean;
  /** 두줄 나누기: 당초 줄(열)에도 수식 유지. 기본 false(값) */
  keepOriginFormulas?: boolean;
  onKeepOriginFormulasChange?: (value: boolean) => void;
  isHiddenSheetShow: boolean;
  gapjiOption: string;
  divideDirectionOption: string;
  macroType: ExcelItem[];
  macroCategories: any[];
  selectedCategoryIndex: number;
  selectedItemId: string;
  selectedItemInfo: any;
  includeReestimationSheet: boolean;
  presets: PresetItem[];
  isPresetModalOpen: boolean;
  currentPresetType: "fieldRepresentative" | "companyInfo" | "projectInfo";
  editingPreset: PresetItem | null;
  selectedPresets: {
    fieldRepresentative?: PresetItem;
    companyInfo?: PresetItem;
    projectInfo?: PresetItem;
  };
  expandedFiles: Set<number>;
  advancePayment: string;
  completionSettlementAmount: string;
  claimDate: string;
  claimAmount: string;
  // 선급금 신청서 관련 props
  contractMaterialCost: string;
  contractIndirectLaborCost: string;
  contractExpenses: string;
  contractOther: string;
  prepaymentAdjustmentMaterialCost: string;
  prepaymentAdjustmentIndirectLaborCost: string;
  prepaymentExpenses: string;
  prepaymentOther: string;
  handleReestimationSheetChange: (value: boolean) => void;
  requiresFile: (itemId: string) => boolean;
  requiresPreset: (itemId: string) => boolean;
  isFormInput: (itemId: string) => boolean;
  handleDragOver: (e: React.DragEvent) => void;
  handleDrop: (e: React.DragEvent) => void;
  handleChangeFiles: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDelete: (index: number) => (e: React.MouseEvent) => void;
  handleOnOriginChange: (value: string) => void;
  handleOnDivideChange: (value: string) => void;
  handleOnOriginRowChange: (value: boolean) => void;
  handleOnGapjiChange: (value: string) => void;
  handleOnDivideDirectionChange: (value: string) => void;
  handleAdvancePaymentChange: (value: string) => void;
  handleCompletionSettlementAmountChange: (value: string) => void;
  handleClaimDateChange: (value: string) => void;
  handleClaimAmountChange: (value: string) => void;
  // 선급금 신청서 핸들러들
  handleContractMaterialCostChange: (value: string) => void;
  handleContractIndirectLaborCostChange: (value: string) => void;
  handleContractExpensesChange: (value: string) => void;
  handleContractOtherChange: (value: string) => void;
  handlePrepaymentAdjustmentMaterialCostChange: (value: string) => void;
  handlePrepaymentAdjustmentIndirectLaborCostChange: (value: string) => void;
  handlePrepaymentExpensesChange: (value: string) => void;
  handlePrepaymentOtherChange: (value: string) => void;
  handleEntireCheck: (index: number) => void;
  handleSheetClick: (fileIndex: number, sheet: ExcelX2FileSheet) => void;
  /** 통합문서 시트(일위대가·단가산출·수량산출 등) 선택 해제 — 예상 시간이 한도를 넘을 때 안내 버튼 */
  handleUncheckNonStatementSheets?: () => void;
  /** 한도의 80% 안에 드는 앞쪽 시트만 남기고 나머지 선택 해제 — "N개씩 나눠 실행" 버튼 */
  handleKeepSheetsWithinLimit?: () => void;
  handleExecute: () => void;
  handleHiddenSheetClick: () => void;
  onClickCategory: (index: number) => void;
  onSelectItem: (itemId: string) => void;
  // 이용권으로 쓸 수 없는 항목/카테고리 — "구매 필요"로 표시한다. 없으면 잠금 표시 없음.
  isItemLocked?: (itemId: string) => boolean;
  isCategoryLocked?: (category: any) => boolean;
  onOpenPresetModal: (
    type: "fieldRepresentative" | "companyInfo" | "projectInfo"
  ) => void;
  onEditPreset: (preset: PresetItem | null) => void;
  onSavePreset: (preset: Omit<PresetItem, "id" | "createdAt">) => void;
  onDeletePreset: (preset: PresetItem) => void;
  onClosePresetModal: () => void;
  onSelectPreset: (
    type: "fieldRepresentative" | "companyInfo" | "projectInfo",
    preset?: PresetItem
  ) => void;
  onToggleFileExpanded: (fileIndex: number) => void;
  defaultPresets?: {
    companyInfo?: PresetItem;
    fieldRepresentative?: PresetItem;
    projectInfo?: PresetItem;
  };
  onSetDefaultPreset: (
    type: "companyInfo" | "fieldRepresentative" | "projectInfo",
    preset?: PresetItem
  ) => void;
  onReset: () => void;
  onDocumentGenerate: (
    itemId: string,
    presets?: any,
    scheduleData?: any
  ) => void;
  safetyManagePlan: any;
  onSafetyManagePlanChange: (data: any) => void;
  enviManagePlan: any;
  onEnviManagePlanChange: (data: any) => void;
  getDefaultPresetsFromStorage: () => any;
  saveDefaultPresetsToStorage: (defaultPresets: any) => void;
  onClearDefaultPreset: (
    type: "companyInfo" | "fieldRepresentative" | "projectInfo"
  ) => void;
  onClearAllPresets: () => void;
  scheduleData: any;
  onScheduleDataChange: (data: any) => void;
  // 차수분 내역서 관련 props
  phaseCount: number;
  phaseTexts: string[];
  totalText: string;
  remainderText: string;
  useExistingFiles: boolean;
  phaseFiles: any[];
  isLoadingPhaseSheets: boolean;
  isProcessing: boolean;
  phaseFileInputRefs: React.MutableRefObject<{ [key: number]: HTMLInputElement | null }>;
  onPhaseCountChange: (value: number) => void;
  onPhaseTextsChange: (value: string[]) => void;
  onTotalTextChange: (value: string) => void;
  onRemainderTextChange: (value: string) => void;
  onUseExistingFilesChange: (value: boolean) => void;
  onPhaseFileChange: (e: React.ChangeEvent<HTMLInputElement>, phase: number) => void;
  onDeletePhaseFile: (phase: number) => void;
  onPhasedStatementExecution: () => void;
  onShowAlert: (message: string) => void;
  // 증감내역서: 증(+)/감(-) 분리 컬럼 양식 사용 여부 (change-2 전용)
  useSeparatedColumns: boolean;
  onUseSeparatedColumnsChange: (value: boolean) => void;
}

const ExcelPresenter = (props: Props) => {
  const [dragOver, setDragOver] = useState(false);
  const dragCounter = useRef(0);
  const history = useHistory();
  const alertContext = useContext(AlertContext);

  // 발주처(B2B) 모드: 이용권 구매 유도 대신 "발주처가 열지 않은 기능" 안내
  const tenant = useTenant();
  // 이용권 잠금 표시 도우미
  const itemLocked = (itemId: string) =>
    !!props.isItemLocked && props.isItemLocked(itemId);
  const categoryLocked = (category: any) =>
    !!props.isCategoryLocked && props.isCategoryLocked(category);
  const lockedBadge = (
    <span
      className="badge ms-2"
      style={{
        backgroundColor: "#fef3c7",
        color: "#b45309",
        border: "1px solid #fcd34d",
        padding: "0.2rem 0.4rem",
        borderRadius: "4px",
        fontSize: "0.65rem",
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {tenant ? "미개방" : "구매 필요"}
    </span>
  );

  // 카테고리별 ref 생성
  const categoryRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  // 선택된 항목이 있는 카테고리만 펼쳐지도록 초기화
  const getInitialExpandedCategories = () => {
    if (!props.selectedItemId) return new Set<string>();

    const selectedCategory = props.macroCategories.find((category) =>
      category.items.some(
        (item: any) =>
          item.id === props.selectedItemId ||
          (item.subItems &&
            item.subItems.some(
              (subItem: any) => subItem.id === props.selectedItemId
            ))
      )
    );

    return selectedCategory
      ? new Set([selectedCategory.id])
      : new Set<string>();
  };

  const [expandedCategories, setExpandedCategories] = useState<Set<string>>(
    getInitialExpandedCategories()
  );

  // 전역 상단바 바로 아래에 '현재 작업' 띠를 고정하기 위한 높이 (상단바 높이에 맞춘다)
  const [stickyBarTop, setStickyBarTop] = useState<number>(0);
  React.useEffect(() => {
    const measure = () => {
      const header = document.querySelector("header.sticky-top");
      setStickyBarTop(header ? Math.round(header.getBoundingClientRect().height) : 0);
    };
    // 상단바는 스크롤하면 높이가 줄어들므로 스크롤 때도 다시 잰다.
    // (requestAnimationFrame 은 숨은 탭에서 멈추므로 쓰지 않는다 — 같은 값이면 setState 가 렌더를 건너뛴다)
    measure();
    window.addEventListener("resize", measure);
    window.addEventListener("scroll", measure, { passive: true });
    return () => {
      window.removeEventListener("resize", measure);
      window.removeEventListener("scroll", measure);
    };
  }, []);

  // 현재 선택한 작업이 속한 분류 이름 (예: "변경")
  const selectedCategoryTitle = props.selectedItemId
    ? props.macroCategories.find((category) =>
        category.items.some(
          (item: any) =>
            item.id === props.selectedItemId ||
            (item.subItems &&
              item.subItems.some(
                (subItem: any) => subItem.id === props.selectedItemId
              ))
        )
      )?.title
    : undefined;

  const scrollToTaskTypePanel = () => {
    // 패널 자체는 sticky 라 scrollIntoView 가 엇나가므로, 패널이 든 열의 위치로 맞춘다
    const panel = document.getElementById("excel-task-type-panel");
    const column = panel?.parentElement;
    if (column) {
      const barHeight =
        document.querySelector<HTMLElement>(
          '[data-testid="excel-current-task-bar"]'
        )?.offsetHeight || 0;
      const top =
        column.getBoundingClientRect().top +
        window.scrollY -
        stickyBarTop -
        barHeight -
        24;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // props.selectedItemId가 변경될 때마다 해당 카테고리를 펼치도록
  React.useEffect(() => {
    if (props.selectedItemId) {
      const selectedCategory = props.macroCategories.find((category) =>
        category.items.some(
          (item: any) =>
            item.id === props.selectedItemId ||
            (item.subItems &&
              item.subItems.some(
                (subItem: any) => subItem.id === props.selectedItemId
              ))
        )
      );

      if (selectedCategory) {
        setExpandedCategories(
          (prev) => new Set([...prev, selectedCategory.id])
        );
      }
    }
  }, [props.selectedItemId, props.macroCategories]);

  // 페이지 로드 시 기본 프리셋 자동 적용
  React.useEffect(() => {
    const storedDefaults = props.getDefaultPresetsFromStorage();

    // 저장된 기본 프리셋이 있고, 현재 선택된 프리셋이 없는 경우 자동 적용
    if (storedDefaults.companyInfo && !props.selectedPresets.companyInfo) {
      const companyPreset = props.presets.find(
        (p) => p.id === storedDefaults.companyInfo?.id
      );
      if (companyPreset) {
        props.onSelectPreset("companyInfo", companyPreset);
      }
    }

    if (
      storedDefaults.fieldRepresentative &&
      !props.selectedPresets.fieldRepresentative
    ) {
      const fieldPreset = props.presets.find(
        (p) => p.id === storedDefaults.fieldRepresentative?.id
      );
      if (fieldPreset) {
        props.onSelectPreset("fieldRepresentative", fieldPreset);
      }
    }

    if (storedDefaults.projectInfo && !props.selectedPresets.projectInfo) {
      const projectPreset = props.presets.find(
        (p) => p.id === storedDefaults.projectInfo?.id
      );
      if (projectPreset) {
        props.onSelectPreset("projectInfo", projectPreset);
      }
    }
  }, [
    props.presets,
    props.selectedPresets.companyInfo,
    props.selectedPresets.fieldRepresentative,
    props.selectedPresets.projectInfo,
  ]);

  // Bootstrap 툴팁 초기화
  React.useEffect(() => {
    // Bootstrap 툴팁 초기화
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    const tooltipList = Array.from(tooltipTriggerList).map(
      (tooltipTriggerEl) => {
        // Bootstrap 5의 경우
        try {
          const bootstrap = (window as any).bootstrap;
          if (bootstrap && bootstrap.Tooltip) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
          }
        } catch (error) {
          // Bootstrap tooltip not available
        }
        return null;
      }
    );

    // 정리 함수
    return () => {
      tooltipList.forEach((tooltip) => {
        if (tooltip && tooltip.dispose) {
          tooltip.dispose();
        }
      });
    };
  }, [props.selectedItemInfo]);

  const toggleFileExpanded = (fileIndex: number) => {
    props.onToggleFileExpanded(fileIndex);
  };

  const toggleCategoryExpanded = (categoryId: string) => {
    setExpandedCategories((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(categoryId)) {
        newSet.delete(categoryId);
      } else {
        newSet.add(categoryId);
      }
      return newSet;
    });
  };

  // 메뉴 항목 선택 시 스크롤을 top으로 이동
  const handleItemSelect = (itemId: string) => {
    props.onSelectItem(itemId);

    // 스크롤을 top으로 이동
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getSelectedSheetsCount = (file: ExcelX2File) => {
    return file.sheets?.filter((sheet) => sheet.checked)?.length || 0;
  };

  const getTotalVisibleSheetsCount = (file: ExcelX2File) => {
    return (
      file.sheets?.filter((sheet) => props.isHiddenSheetShow || !sheet.isHidden)
        ?.length || 0
    );
  };

  const getTotalSelectedSheets = () => {
    return props.fileInfos.reduce((total, file) => {
      return (
        total + (file.sheets?.filter((sheet) => sheet.checked)?.length || 0)
      );
    }, 0);
  };

  const getTotalVisibleSheets = () => {
    return props.fileInfos.reduce((total, file) => {
      return (
        total +
        (file.sheets?.filter(
          (sheet) => props.isHiddenSheetShow || !sheet.isHidden
        )?.length || 0)
      );
    }, 0);
  };

  const divStyle = dragOver ? { display: "block" } : { display: "none" };

  const handleDragEnter = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current++;
    if (dragCounter.current > 0) {
      setDragOver(true);
    }
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current--;
    if (dragCounter.current === 0) {
      setDragOver(false);
    }
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current = 0;
    setDragOver(false);
    props.handleDrop(e);
  };

  const handleHelpClick = (item: ExcelItem) => {
    window.open(
      process.env.REACT_APP_URL + "lectureroom/0/" + item?.lectureId,
      "",
      "width=#, height=#"
    );
  };

  // 파일 업로드가 필요 없는 항목들 (기본정보 기반 서류 생성)
  const isPresetBasedItem = (itemId: string) => {
    return !props.requiresFile(itemId);
  };

  // 안전관리비사용계획내역이 선택되었을 때 파일 업로드 영역 대신 모던한 안전관리비 사용계획 폼을 표시하도록 수정합니다.
  const isSafetyManagePlan =
    props.selectedItemId === "start-2-2" ||
    props.selectedItemId === "completion-2-2";

  // 환경보전비 사용내역서가 선택되었는지 확인
  const isEnviManagePlan =
    props.selectedItemId === "start-2-3" ||
    props.selectedItemId === "completion-2-3";

  // 차수분 내역서가 선택되었는지 확인
  const isPhasedStatement = props.selectedItemId === "change-8";


  // 프리셋이 필요한 항목인지 확인 (macroCategories 기반)
  const isPresetRequired = (itemId: string) => {
    return props.requiresPreset(itemId);
  };

  // 필요한 프리셋이 모두 설정되었는지 확인
  const hasRequiredPresets = () => {
    // 프리셋이 필수가 아닌 경우 true 반환
    if (!props.requiresPreset(props.selectedItemId)) {
      return true;
    }

    // 1. 회사정보 확인 - 페이지에서 실제로 선택된 것만 확인
    const selectedCompany = props.selectedPresets.companyInfo;
    if (!selectedCompany) {
      return false;
    }

    // 선택된 회사정보가 실제로 존재하는지 확인 (삭제된 프리셋이 기본 프리셋으로 남아있는 경우 방지)
    const companyExists = props.presets.find(
      (p) => p.id === selectedCompany.id && p.type === "companyInfo"
    );
    if (!companyExists) {
      return false;
    }

    // 2. 선택된 회사정보에 연결된 현장대리인 확인 - 페이지에서 실제로 선택된 것만 확인
    const selectedFieldRep = props.selectedPresets.fieldRepresentative;
    if (!selectedFieldRep) {
      return false;
    }

    // 현장대리인이 실제로 존재하는지 확인
    const fieldRepExists = props.presets.find(
      (p) => p.id === selectedFieldRep.id && p.type === "fieldRepresentative"
    );
    if (!fieldRepExists) {
      return false;
    }

    // 현장대리인이 선택된 회사정보에 연결되어 있는지 확인
    const fieldRepData = selectedFieldRep.data as any;
    const companyIdFromFieldRep = fieldRepData.companyId;
    const companyIdFromCompany = selectedCompany.id.split("-")[0];
    if (
      fieldRepData.companyId &&
      String(fieldRepData.companyId) !== String(companyIdFromCompany)
    ) {
      return false;
    }

    // 3. 선택된 회사정보에 연결된 공사정보 확인 - 페이지에서 실제로 선택된 것만 확인
    const selectedProjectInfo = props.selectedPresets.projectInfo;
    if (!selectedProjectInfo) {
      return false;
    }

    // 공사정보가 실제로 존재하는지 확인
    const projectInfoExists = props.presets.find(
      (p) => p.id === selectedProjectInfo.id && p.type === "projectInfo"
    );
    if (!projectInfoExists) {
      return false;
    }

    // 공사정보가 선택된 회사정보에 연결되어 있는지 확인
    const projectInfoData = selectedProjectInfo.data as any;
    const companyIdFromProject = projectInfoData.companyId;
    if (
      projectInfoData.companyId &&
      String(projectInfoData.companyId) !== String(companyIdFromCompany)
    ) {
      return false;
    }

    return true;
  };

  // 기본 프리셋이 모두 설정되어 있는지 확인
  const hasDefaultPresets = () => {
    const storedDefaults = props.getDefaultPresetsFromStorage();
    return (
      storedDefaults?.companyInfo &&
      storedDefaults?.fieldRepresentative &&
      storedDefaults?.projectInfo
    );
  };

  // 로그인 상태 확인 후 기본정보 설정 모달 열기
  const handleOpenPresetModalWithLoginCheck = (
    type: "fieldRepresentative" | "companyInfo" | "projectInfo"
  ) => {
    if (!util.isLogin()) {
      alertContext.showAlert("로그인이 필요합니다.", () => {
        history.push(pages.login);
      });
      return;
    }
    props.onOpenPresetModal(type);
  };

  // 공통 함수
  function convertCommaValue(value: any) {
    value = Number(value.replaceAll(",", ""));
    if (isNaN(value)) {
      return 0;
    } else {
      const formatValue = value.toLocaleString("ko-KR");
      return formatValue;
    }
  }

  // 기성내역서 항목인지 확인하는 함수
  const isProgressReportItem = (itemId: string) => {
    // 기성내역서 관련 항목 ID들을 확인 (실제 항목 ID에 맞게 수정 필요)
    return (
      itemId?.includes("progress") ||
      itemId?.includes("기성") ||
      props.selectedItemInfo?.title?.includes("기성")
    );
  };

  // 준공정산금액 입력이 필요한 항목인지 확인하는 함수
  const isCompletionSettlementItem = (itemId: string) => {
    // 준공계 서류만 필요
    return itemId === "completion-2-1";
  };

  // 청구서류 항목인지 확인하는 함수
  const isBillingItem = (itemId: string) => {
    // 청구서류 관련 항목 ID들을 확인
    return (
      itemId?.includes("billing") ||
      props.selectedItemInfo?.title?.includes("청구")
    );
  };

  // 선급금 신청서 항목인지 확인하는 함수
  const isPrepaymentItem = (itemId: string) => {
    return (
      itemId === "start-3" ||
      itemId?.includes("prepayment") ||
      props.selectedItemInfo?.title?.includes("선급금")
    );
  };

  // 예정공정표가 완성되었는지 확인하는 함수
  const isScheduleFormComplete = () => {
    // 예정공정표가 필요한 항목만 체크
    const scheduleRequiredItems = ["start-2-1"]; // 필요에 따라 다른 항목 ID도 추가 가능
    if (!scheduleRequiredItems.includes(props.selectedItemId)) {
      return true;
    }

    // scheduleData가 없으면 미완성
    if (!props.scheduleData || !props.scheduleData.rows) {
      return false;
    }

    const {
      rows,
      startDate,
      completionDate,
      totalWorkDays,
      workPeriodDistribution,
      subHeaderDates,
    } = props.scheduleData;

    // 착공일과 준공일이 입력되어야 함
    if (!startDate || !completionDate) {
      return false;
    }

    // 착공일이 준공일보다 늦을 수 없음
    if (startDate > completionDate) {
      return false;
    }

    // 총 공사기간이 0보다 커야 함
    if (!totalWorkDays || totalWorkDays <= 0) {
      return false;
    }

    // 최소 1개 행은 있어야 함
    if (rows.length === 0) {
      return false;
    }

    // 모든 행이 완성되었는지 확인
    for (let i = 0; i < rows.length; i++) {
      const item = rows[i];

      // 공종명이 비어있으면 미완성
      if (!item.workTypeName || item.workTypeName.trim() === "") {
        return false;
      }

      // 합계금액이 비어있거나 0이면 미완성
      if (
        !item.totalAmount ||
        item.totalAmount.trim() === "" ||
        item.totalAmount === "0"
      ) {
        return false;
      }

      // 공사기간이 모두 0이면 미완성 (최소 1개 구간은 활성화되어야 함)
      const hasActivePeriod = item.selectedPeriods.some(
        (isSelected: boolean) => isSelected
      );
      if (!hasActivePeriod) {
        return false;
      }
    }

    return true;
  };

  return (
    <div
      className="container-fluid py-4"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <div className="container">
        {/* 헤더 섹션 */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div>
                {props.selectedItemInfo ? (
                  <>
                    <h2 className="fw-bold text-dark mb-1">
                      {props.selectedItemInfo.title}
                    </h2>
                    <p className="text-muted mb-0">
                      {props.selectedItemInfo.description}
                    </p>
                  </>
                ) : (
                  <>
                    <h2 className="fw-bold text-dark mb-1">엑셀 자동화 도구</h2>
                    <p className="text-muted mb-0">
                      효율적인 엑셀 작업을 위한 스마트 솔루션
                    </p>
                  </>
                )}
              </div>
              <div className="d-flex gap-2">
                {/* 기본정보설정 버튼 - 항상 표시 */}
                <button
                  onClick={() =>
                    handleOpenPresetModalWithLoginCheck("companyInfo")
                  }
                  className="btn btn-outline-success d-flex align-items-center"
                  title="기본정보 관리"
                >
                  <span className="material-symbols-outlined me-2">
                    bookmark_manager
                  </span>
                  기본정보 설정
                </button>

                {/* 도움말 버튼 — 콘엑스 강의실 팝업이라 발주처 모드에선 숨긴다 */}
                {!tenant && props.selectedItemInfo?.lectureId && (
                  <button
                    className="btn btn-outline-info d-flex align-items-center"
                    onClick={() => handleHelpClick(props.selectedItemInfo)}
                  >
                    <span className="material-symbols-outlined me-2">help</span>
                    도움말
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* 현재 작업 띠 - 스크롤해도 상단바 아래에 고정되어 무엇을 선택했는지 보여준다 */}
        {props.selectedItemInfo && (
          <div
            className="sticky-top mb-3"
            data-testid="excel-current-task-bar"
            style={{ top: `${stickyBarTop}px`, zIndex: 45 }}
          >
            <div
              className="d-flex align-items-center justify-content-between bg-white border rounded-3 shadow-sm px-3 py-2"
              style={{ borderColor: "#cfe2ff" }}
            >
              <div className="d-flex align-items-center text-truncate">
                <span
                  className="material-symbols-outlined text-primary me-2"
                  style={{ fontSize: "18px" }}
                >
                  check_circle
                </span>
                <span className="text-muted small me-2">현재 작업</span>
                {selectedCategoryTitle && (
                  <span className="text-muted me-2">{selectedCategoryTitle} ›</span>
                )}
                <span className="fw-bold text-dark text-truncate">
                  {props.selectedItemInfo.title}
                </span>
              </div>
              <button
                type="button"
                className="btn btn-outline-primary btn-sm d-flex align-items-center flex-shrink-0 ms-2"
                onClick={scrollToTaskTypePanel}
                title="작업 유형 선택으로 이동"
              >
                <span
                  className="material-symbols-outlined me-1"
                  style={{ fontSize: "16px" }}
                >
                  swap_horiz
                </span>
                다른 작업
              </button>
            </div>
          </div>
        )}

        {/* 네비게이션 바 - 파일이 업로드되었거나 기본정보 기반 항목이 선택되었을 때 표시 */}
        {(props.fileInfos.length > 0 ||
          isSafetyManagePlan ||
          isPhasedStatement ||
          (props.selectedItemId &&
            isPresetBasedItem(props.selectedItemId))) && (
          <div className="card border-0 bg-light mb-4">
            <div className="card-body py-3">
              <div className="d-flex align-items-center justify-content-between">
                {/* Breadcrumb */}
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <span
                        className="text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          // 전체 초기화 실행
                          props.onReset();
                        }}
                      >
                        <span
                          className="material-symbols-outlined me-1"
                          style={{ fontSize: "16px" }}
                        >
                          home
                        </span>
                        엑셀 자동화
                      </span>
                    </li>
                    {props.selectedItemInfo && (
                      <>
                        <li className="breadcrumb-item">
                          <span className="text-muted">
                            {
                              props.macroCategories.find((cat) =>
                                cat.items.some(
                                  (item: any) =>
                                    item.id === props.selectedItemId ||
                                    (item.subItems &&
                                      item.subItems.some(
                                        (sub: any) =>
                                          sub.id === props.selectedItemId
                                      ))
                                )
                              )?.title
                            }
                          </span>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          <span className="fw-semibold text-dark">
                            {props.selectedItemInfo.title}
                          </span>
                        </li>
                      </>
                    )}
                    {props.fileInfos.length > 0 && !isSafetyManagePlan && (
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        <span className="fw-semibold text-dark">
                          파일 업로드 완료
                        </span>
                      </li>
                    )}
                  </ol>
                </nav>

                {/* 액션 버튼들 */}
                <div className="d-flex gap-2">
                  {/* 뒤로가기 버튼 */}
                  <button
                    className="btn btn-outline-secondary btn-sm d-flex align-items-center"
                    onClick={() => {
                      // 전체 초기화
                      props.onReset();
                    }}
                    title="처음으로 돌아가기"
                  >
                    <span
                      className="material-symbols-outlined me-1"
                      style={{ fontSize: "16px" }}
                    >
                      arrow_back
                    </span>
                    뒤로가기
                  </button>

                  {/* 다른 기능 선택 버튼 */}
                  <div className="d-flex gap-2">
                    <div className="dropdown">
                      <button
                        className="btn btn-outline-primary btn-sm dropdown-toggle d-flex align-items-center"
                        type="button"
                        id="functionDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span
                          className="material-symbols-outlined me-1"
                          style={{ fontSize: "16px" }}
                        >
                          swap_horiz
                        </span>
                        다른 기능 선택
                      </button>
                      <ul
                        className="dropdown-menu"
                        style={{ zIndex: "100", overflowY: "auto" }}
                        aria-labelledby="functionDropdown"
                      >
                        {props.macroCategories.map((category) => (
                          <li key={category.id}>
                            <h6 className="dropdown-header d-flex align-items-center">
                              <span
                                className="material-symbols-outlined me-1"
                                style={{ fontSize: "14px" }}
                              >
                                {category.icon}
                              </span>
                              {category.title}
                              {categoryLocked(category) && lockedBadge}
                            </h6>
                            {category.items.map((item: any) => (
                              <div key={item.id}>
                                {item.subItems ? (
                                  // 하위 항목이 있는 경우 선택 불가능한 헤더로 표시
                                  <span
                                    className="dropdown-item-text text-muted fw-semibold"
                                    style={{
                                      backgroundColor: "#e2e8f0",
                                      border: "1px solid #cbd5e1",
                                      margin: "2px 0",
                                      borderRadius: "6px",
                                      padding: "8px 12px",
                                    }}
                                  >
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="d-flex align-items-center">
                                        <span
                                          className="material-symbols-outlined me-2"
                                          style={{ fontSize: "16px" }}
                                        >
                                          folder
                                        </span>
                                        <span>
                                          {item.title} ({item.subItems.length}개
                                          항목)
                                        </span>
                                      </div>
                                    </div>
                                  </span>
                                ) : (
                                  // 하위 항목이 없는 경우만 선택 가능
                                  <a
                                    href="#"
                                    className={`dropdown-item ${
                                      props.selectedItemId === item.id
                                        ? "active"
                                        : ""
                                    }`}
                                    style={{
                                      backgroundColor:
                                        props.selectedItemId === item.id
                                          ? "#3b82f6"
                                          : "#ffffff",
                                      border: "1px solid #f1f5f9",
                                      margin: "2px 0",
                                      borderRadius: "6px",
                                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();

                                      // Bootstrap dropdown 닫기
                                      const dropdown =
                                        document.getElementById(
                                          "functionDropdown"
                                        );
                                      if (dropdown) {
                                        const bsDropdown = (
                                          window as any
                                        ).bootstrap?.Dropdown?.getInstance(
                                          dropdown
                                        );
                                        if (bsDropdown) {
                                          bsDropdown.hide();
                                        }
                                      }

                                      // 구매가 필요한 항목이면 올려 둔 파일을 지우지 않고 바로 이용권 안내로 보낸다.
                                      if (itemLocked(item.id)) {
                                        handleItemSelect(item.id);
                                        return;
                                      }

                                      // 파일이 불필요한 항목이면 파일 삭제, 일반 항목이면 파일 유지
                                      if (!props.requiresFile(item.id)) {
                                        // 파일이 불필요한 항목은 파일 삭제
                                        props.fileInfos.forEach((_, index) => {
                                          try {
                                            const mockEvent = {
                                              preventDefault: () => {},
                                              stopPropagation: () => {},
                                              currentTarget: null,
                                              target: null,
                                              type: "click",
                                              bubbles: false,
                                              cancelable: true,
                                              defaultPrevented: false,
                                              eventPhase: 0,
                                              isTrusted: false,
                                              timeStamp: Date.now(),
                                            } as unknown as React.MouseEvent;
                                            props.handleDelete(index)(
                                              mockEvent
                                            );
                                          } catch (error) {
                                            console.warn(
                                              "파일 삭제 중 오류:",
                                              error
                                            );
                                          }
                                        });
                                      }
                                      // 항목 선택
                                      handleItemSelect(item.id);
                                    }}
                                  >
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="d-flex align-items-center">
                                        <span
                                          className="material-symbols-outlined me-2"
                                          style={{ fontSize: "16px" }}
                                        >
                                          description
                                        </span>
                                        <span>{item.title}</span>
                                      </div>
                                      {itemLocked(item.id) && lockedBadge}
                                      {item.tag && item.tag !== "무료" && (
                                        <span className="badge bg-success ms-2">
                                          {item.tag}
                                        </span>
                                      )}
                                    </div>
                                  </a>
                                )}
                                {item.subItems &&
                                  item.subItems.map((subItem: any) => (
                                    <a
                                      key={subItem.id}
                                      href="#"
                                      className={`dropdown-item ps-4 ${
                                        props.selectedItemId === subItem.id
                                          ? "active"
                                          : ""
                                      }`}
                                      style={{
                                        backgroundColor:
                                          props.selectedItemId === subItem.id
                                            ? "#3b82f6"
                                            : "#ffffff",
                                        border: "1px solid #f1f5f9",
                                        margin: "2px 0",
                                        borderRadius: "6px",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        // Bootstrap dropdown 닫기
                                        const dropdown =
                                          document.getElementById(
                                            "functionDropdown"
                                          );
                                        if (dropdown) {
                                          const bsDropdown = (
                                            window as any
                                          ).bootstrap?.Dropdown?.getInstance(
                                            dropdown
                                          );
                                          if (bsDropdown) {
                                            bsDropdown.hide();
                                          }
                                        }

                                        if (itemLocked(subItem.id)) {
                                          handleItemSelect(subItem.id);
                                          return;
                                        }

                                        // 파일이 불필요한 항목이면 파일 삭제, 일반 항목이면 파일 유지
                                        if (!props.requiresFile(subItem.id)) {
                                          // 파일이 불필요한 항목은 파일 삭제
                                          props.fileInfos.forEach(
                                            (_, index) => {
                                              try {
                                                const mockEvent = {
                                                  preventDefault: () => {},
                                                  stopPropagation: () => {},
                                                  currentTarget: null,
                                                  target: null,
                                                  type: "click",
                                                  bubbles: false,
                                                  cancelable: true,
                                                  defaultPrevented: false,
                                                  eventPhase: 0,
                                                  isTrusted: false,
                                                  timeStamp: Date.now(),
                                                } as unknown as React.MouseEvent;
                                                props.handleDelete(index)(
                                                  mockEvent
                                                );
                                              } catch (error) {
                                                console.warn(
                                                  "파일 삭제 중 오류:",
                                                  error
                                                );
                                              }
                                            }
                                          );
                                        }
                                        // 항목 선택
                                        handleItemSelect(subItem.id);
                                      }}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span
                                          className="material-symbols-outlined me-2"
                                          style={{ fontSize: "16px" }}
                                        >
                                          description
                                        </span>
                                        <span>↳ {subItem.title}</span>
                                        {itemLocked(subItem.id) && lockedBadge}
                                      </div>
                                    </a>
                                  ))}
                              </div>
                            ))}
                            {category !==
                              props.macroCategories[
                                props.macroCategories.length - 1
                              ] && (
                              <li>
                                <hr className="dropdown-divider" />
                              </li>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 메인 컨텐츠 영역 - 3컬럼 레이아웃 */}
        <div className="row g-4">
          {/* 왼쪽: 작업 유형 선택 - 항상 표시 */}
          <div className="col-lg-3">
            <div
              id="excel-task-type-panel"
              className="sticky-top"
              style={{
                top: "150px",
                zIndex: 40,
              }}
            >
              <div
                className="card shadow-sm"
                style={{
                  border: "none",
                  borderRadius: "16px",
                }}
              >
                <div
                  className="card-header bg-white border-0 pt-4"
                  style={{ borderRadius: "16px 16px 0 0" }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className="card-title mb-0 d-flex align-items-center">
                      <span className="material-symbols-outlined me-2 text-primary">
                        category
                      </span>
                      작업 유형 선택
                    </h5>
                  </div>

                  {/* 선택된 항목 정보 */}
                  {props.selectedItemInfo && (
                    <div className="mt-3 p-3 bg-primary bg-opacity-10 border border-primary border-opacity-25 rounded-3">
                      <div className="d-flex align-items-start">
                        <span className="material-symbols-outlined text-primary me-2 mt-1">
                          check_circle
                        </span>
                        <div className="flex-grow-1">
                          <h6 className="fw-bold text-primary mb-0">
                            {props.selectedItemInfo.title}
                          </h6>
                          <p className="text-dark mb-0 small">
                            {props.selectedItemInfo.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="card-body">
                  {/* 항목 선택 안내 */}
                  {!props.selectedItemInfo && (
                    <div className="mb-4 p-3 bg-light rounded-3 text-center">
                      <span
                        className="material-symbols-outlined text-muted mb-2 d-block"
                        style={{ fontSize: "2rem" }}
                      >
                        touch_app
                      </span>
                      <p className="text-muted mb-0">
                        아래에서 작업할 항목을 선택해주세요
                      </p>
                    </div>
                  )}

                  {/* 컴팩트한 카테고리 레이아웃 */}
                  <div className="d-flex flex-column" style={{ gap: "1rem" }}>
                    {props.macroCategories.map((category, categoryIndex) => {
                      const isExpanded = expandedCategories.has(category.id);

                      return (
                        <div
                          key={category.id}
                          ref={(el) => {
                            categoryRefs.current[category.id] = el;
                          }}
                          className="overflow-hidden"
                          style={{
                            backgroundColor: "#f8fafc",
                            borderRadius: "12px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            border: "1px solid #f0f0f0",
                          }}
                        >
                          {/* 카테고리 헤더 - 클릭 가능한 아코디언 */}
                          <div
                            className="d-flex align-items-center justify-content-between cursor-pointer"
                            onClick={() => toggleCategoryExpanded(category.id)}
                            style={{
                              cursor: "pointer",
                              opacity: categoryLocked(category) ? 0.6 : 1,
                              padding: "0.5rem 1rem",
                              backgroundColor: "#f8fafc",
                              borderBottom: "none",
                              transition: "all 0.2s ease",
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <div
                                className="d-flex align-items-center justify-content-center me-2"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  backgroundColor: "#e7f3ff",
                                  borderRadius: "8px",
                                  color: "#3b82f6",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{ fontSize: "16px" }}
                                >
                                  {category.icon}
                                </span>
                              </div>
                              <div className="d-flex flex-column">
                                <span
                                  className="mb-0 fw-bold text-dark"
                                  style={{ fontSize: "0.9rem" }}
                                >
                                  {category.title}
                                  {categoryLocked(category) && lockedBadge}
                                </span>
                                <small
                                  className="text-muted"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {categoryLocked(category)
                                    ? (tenant ? "발주처 미개방" : "엑셀올인원 패키지 구매 필요")
                                    : `${category.items.length}개 항목`}
                                </small>
                              </div>
                            </div>

                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                width: "24px",
                                height: "24px",
                                backgroundColor: isExpanded
                                  ? "#3b82f6"
                                  : "#e2e8f0",
                                borderRadius: "6px",
                                transition: "all 0.2s ease",
                              }}
                            >
                              <span
                                className="material-symbols-outlined"
                                style={{
                                  fontSize: "14px",
                                  color: isExpanded ? "#ffffff" : "#64748b",
                                  transform: isExpanded
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                  transition: "transform 0.2s ease",
                                }}
                              >
                                expand_more
                              </span>
                            </div>
                          </div>

                          {/* 카테고리 컨텐츠 - 아코디언 바디 */}
                          <div
                            className="overflow-hidden"
                            style={{
                              maxHeight: isExpanded ? "1000px" : "0px",
                              transition:
                                "max-height 0.3s ease, opacity 0.2s ease",
                              opacity: isExpanded ? 1 : 0,
                              backgroundColor: "#f8fafc",
                            }}
                          >
                            <div style={{ padding: "0.5rem 1rem 1rem" }}>
                              <div
                                className="d-flex flex-column"
                                style={{ gap: "0.5rem" }}
                              >
                                {category.items.map((item: any) => (
                                  <div key={item.id}>
                                    <div
                                      className={
                                        item.subItems ? "" : "cursor-pointer"
                                      }
                                      onClick={() => {
                                        if (!item.subItems) {
                                          handleItemSelect(item.id);
                                        }
                                      }}
                                      style={{
                                        cursor: item.subItems
                                          ? "default"
                                          : "pointer",
                                        opacity: itemLocked(item.id) ? 0.55 : 1,
                                        padding: "0.5rem",
                                        borderRadius: "8px",
                                        backgroundColor:
                                          props.selectedItemId === item.id
                                            ? "#3b82f6"
                                            : item.subItems
                                            ? "transparent" // 클릭 불가능한 폴더: 회색 계열
                                            : "#ffffff", // 클릭 가능한 요소: 흰색
                                        border: item.subItems
                                          ? "1px solid none" // 폴더: 회색 테두리
                                          : "1px solid #f1f5f9", // 문서: 연한 테두리
                                        transition: "all 0.2s ease",
                                        transform:
                                          props.selectedItemId === item.id
                                            ? "translateY(-1px)"
                                            : "none",
                                        boxShadow:
                                          props.selectedItemId === item.id
                                            ? "0 4px 12px rgba(59, 130, 246, 0.3)"
                                            : item.subItems
                                            ? "none" // 폴더: 약간의 그림자
                                            : "0 1px 3px rgba(0,0,0,0.1)", // 문서: 더 뚜렷한 그림자
                                      }}
                                      onMouseEnter={(e) => {
                                        if (props.selectedItemId !== item.id) {
                                          if (item.subItems) {
                                            // 폴더: 약간 더 어두운 회색
                                            e.currentTarget.style.backgroundColor =
                                              "transparent";
                                            e.currentTarget.style.borderColor =
                                              "none";
                                            e.currentTarget.style.boxShadow =
                                              "none";
                                          } else {
                                            // 문서: 연한 파란색 계열
                                            e.currentTarget.style.backgroundColor =
                                              "#f0f9ff";
                                            e.currentTarget.style.borderColor =
                                              "#0ea5e9";
                                            e.currentTarget.style.transform =
                                              "translateY(-1px)";
                                            e.currentTarget.style.boxShadow =
                                              "0 4px 8px rgba(0,0,0,0.15)";
                                          }
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        if (props.selectedItemId !== item.id) {
                                          if (item.subItems) {
                                            // 폴더: 원래 회색으로 복귀
                                            e.currentTarget.style.backgroundColor =
                                              "transparent";
                                            e.currentTarget.style.borderColor =
                                              "none";
                                            e.currentTarget.style.boxShadow =
                                              "none";
                                          } else {
                                            // 문서: 원래 흰색으로 복귀
                                            e.currentTarget.style.backgroundColor =
                                              "#ffffff";
                                            e.currentTarget.style.borderColor =
                                              "#f1f5f9";
                                            e.currentTarget.style.transform =
                                              "none";
                                            e.currentTarget.style.boxShadow =
                                              "0 1px 3px rgba(0,0,0,0.1)";
                                          }
                                        }
                                      }}
                                    >
                                      <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center flex-grow-1">
                                          {/* 좌측 아이콘 */}
                                          <span
                                            className="material-symbols-outlined me-2"
                                            style={{
                                              fontSize: "18px",
                                              color:
                                                props.selectedItemId === item.id
                                                  ? "#ffffff"
                                                  : item.subItems
                                                  ? "#64748b"
                                                  : "#1e293b",
                                            }}
                                          >
                                            {item.subItems
                                              ? "folder"
                                              : itemLocked(item.id)
                                              ? "lock"
                                              : "description"}
                                          </span>

                                          <span
                                            className="fw-semibold"
                                            style={{
                                              color:
                                                props.selectedItemId === item.id
                                                  ? "#ffffff"
                                                  : item.subItems
                                                  ? "#64748b"
                                                  : "#1e293b",
                                              fontSize: "0.85rem",
                                            }}
                                          >
                                            {item.title}
                                            {item.subItems && (
                                              <span
                                                className="text-muted ms-1 small"
                                                style={{
                                                  fontSize: "0.7rem",
                                                  opacity: 0.7,
                                                }}
                                              >
                                                ({item.subItems.length})
                                              </span>
                                            )}
                                          </span>
                                        </div>
                                        <div className="d-flex align-items-center">
                                          {props.selectedItemId === item.id && (
                                            <span
                                              className="material-symbols-outlined me-1"
                                              style={{
                                                fontSize: "16px",
                                                color: "#ffffff",
                                              }}
                                            >
                                              check_circle
                                            </span>
                                          )}
                                          {itemLocked(item.id) && lockedBadge}
                                          {item.tag && item.tag !== "무료" && (
                                            <span
                                              className="badge small"
                                              style={{
                                                backgroundColor:
                                                  props.selectedItemId ===
                                                  item.id
                                                    ? "#ffffff"
                                                    : "#10b981",
                                                color:
                                                  props.selectedItemId ===
                                                  item.id
                                                    ? "#3b82f6"
                                                    : "#ffffff",
                                                padding: "0.2rem 0.4rem",
                                                borderRadius: "4px",
                                                fontSize: "0.65rem",
                                                fontWeight: "500",
                                              }}
                                            >
                                              {item.tag}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    {/* 소분류 항목들 */}
                                    {item.subItems && (
                                      <div className="ms-2 mt-2">
                                        {item.subItems.map((subItem: any) => (
                                          <div
                                            key={subItem.id}
                                            className="cursor-pointer"
                                            onClick={() =>
                                              handleItemSelect(subItem.id)
                                            }
                                            style={{
                                              cursor: "pointer",
                                              padding: "0.6rem 0.8rem",
                                              marginBottom: "0.5rem",
                                              borderRadius: "6px",
                                              backgroundColor:
                                                props.selectedItemId ===
                                                subItem.id
                                                  ? "#3b82f6"
                                                  : "#ffffff",
                                              border: `1px solid ${
                                                props.selectedItemId ===
                                                subItem.id
                                                  ? "#3b82f6"
                                                  : "#f1f5f9"
                                              }`,
                                              transition: "all 0.2s ease",
                                              fontSize: "0.8rem",
                                              boxShadow:
                                                props.selectedItemId ===
                                                subItem.id
                                                  ? "0 2px 8px rgba(59, 130, 246, 0.2)"
                                                  : "0 1px 2px rgba(0,0,0,0.03)",
                                              position: "relative",
                                            }}
                                            onMouseEnter={(e) => {
                                              if (
                                                props.selectedItemId !==
                                                subItem.id
                                              ) {
                                                e.currentTarget.style.backgroundColor =
                                                  "#f8fafc";
                                                e.currentTarget.style.borderColor =
                                                  "#e2e8f0";
                                                e.currentTarget.style.boxShadow =
                                                  "0 2px 4px rgba(0,0,0,0.08)";
                                                e.currentTarget.style.transform =
                                                  "translateX(4px)";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (
                                                props.selectedItemId !==
                                                subItem.id
                                              ) {
                                                e.currentTarget.style.backgroundColor =
                                                  "#ffffff";
                                                e.currentTarget.style.borderColor =
                                                  "#f1f5f9";
                                                e.currentTarget.style.boxShadow =
                                                  "0 1px 2px rgba(0,0,0,0.03)";
                                                e.currentTarget.style.transform =
                                                  "translateX(0px)";
                                              }
                                            }}
                                          >
                                            {/* 좌측 accent 선 */}
                                            <div
                                              style={{
                                                position: "absolute",
                                                left: 0,
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                width: "2px",
                                                height: "60%",
                                                backgroundColor:
                                                  props.selectedItemId ===
                                                  subItem.id
                                                    ? "#ffffff"
                                                    : "#cbd5e1",
                                                borderRadius: "0 2px 2px 0",
                                                transition: "all 0.2s ease",
                                              }}
                                            />

                                            <div className="d-flex align-items-center justify-content-between ms-1">
                                              <div className="d-flex align-items-center">
                                                {/* 문서 아이콘 */}
                                                <span
                                                  className="material-symbols-outlined me-2"
                                                  style={{
                                                    fontSize: "16px",
                                                    color:
                                                      props.selectedItemId ===
                                                      subItem.id
                                                        ? "#ffffff"
                                                        : "#64748b",
                                                  }}
                                                >
                                                  description
                                                </span>
                                                <span
                                                  className="fw-semibold"
                                                  style={{
                                                    color:
                                                      props.selectedItemId ===
                                                      subItem.id
                                                        ? "#ffffff"
                                                        : "#475569",
                                                  }}
                                                >
                                                  {subItem.title}
                                                </span>
                                                {itemLocked(subItem.id) && lockedBadge}
                                                {subItem.tag &&
                                                  subItem.tag !== "무료" && (
                                                    <span
                                                      className="badge ms-2 small"
                                                      style={{
                                                        backgroundColor:
                                                          props.selectedItemId ===
                                                          subItem.id
                                                            ? "#ffffff"
                                                            : "#10b981",
                                                        color:
                                                          props.selectedItemId ===
                                                          subItem.id
                                                            ? "#3b82f6"
                                                            : "#ffffff",
                                                        padding:
                                                          "0.15rem 0.3rem",
                                                        borderRadius: "3px",
                                                        fontSize: "0.6rem",
                                                        fontWeight: "500",
                                                      }}
                                                    >
                                                      {subItem.tag}
                                                    </span>
                                                  )}
                                              </div>
                                              {props.selectedItemId ===
                                                subItem.id && (
                                                <span
                                                  className="material-symbols-outlined"
                                                  style={{
                                                    fontSize: "14px",
                                                    color: "#ffffff",
                                                  }}
                                                >
                                                  check_circle
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 중앙: 메인 컨텐츠 영역 */}
          <div className="col-lg-9">
            {/* 구매가 필요한 항목 — 업로드 대신 이용권 안내 */}
            {itemLocked(props.selectedItemId) && (
              <div
                className="card shadow-sm mb-4"
                style={{ border: "none", borderRadius: "16px" }}
              >
                <div className="card-body text-center py-5">
                  <span
                    className="material-symbols-outlined mb-3"
                    style={{ fontSize: "4rem", color: "#b45309" }}
                  >
                    lock
                  </span>
                  <h4 className="fw-bold text-dark mb-2">
                    {tenant ? "이 계정에 열리지 않은 기능입니다" : "구매가 필요한 기능입니다"}
                  </h4>
                  <p className="text-muted mb-4">
                    {tenant ? (
                      <>
                        {props.selectedItemInfo?.title || "이 기능"}은(는) {ownerLabel(tenant)} 담당자가 계정별로 열어 줍니다.
                        <br />
                        필요하면 담당자에게 요청하세요.
                      </>
                    ) : (
                      <>
                        {props.selectedItemInfo?.title || "이 기능"}은(는) 엑셀올인원
                        패키지에 포함되어 있습니다.
                        <br />
                        이용권을 구매하면 바로 사용할 수 있습니다.
                      </>
                    )}
                  </p>
                  {!tenant && (
                  <button
                    type="button"
                    className="btn btn-warning btn-lg px-4 py-3 fw-semibold"
                    onClick={() => history.push(pages.payment)}
                  >
                    <span className="material-symbols-outlined me-2 align-middle">
                      shopping_cart
                    </span>
                    이용권 보기
                  </button>
                  )}
                </div>
              </div>
            )}

            {/* 파일 업로드 영역 - 필요할 때만 표시 */}
            {!itemLocked(props.selectedItemId) &&
              props.fileInfos.length === 0 &&
              (!props.selectedItemId ||
                props.requiresFile(props.selectedItemId)) &&
              !isSafetyManagePlan &&
              !isEnviManagePlan && (
                <div
                  className="card shadow-sm mb-4"
                  style={{
                    border: "none",
                    borderRadius: "16px",
                  }}
                >
                  <div
                    className="card-body text-center py-5 position-relative"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                  >
                    {/* 드래그 오버레이 */}
                    {dragOver && (
                      <div
                        className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "rgba(13, 110, 253, 0.85)",
                          zIndex: 1000,
                          borderRadius: "16px",
                          border: "4px dashed #ffffff",
                          backdropFilter: "blur(2px)",
                          top: 0,
                          left: 0,
                        }}
                      >
                        <div className="text-center">
                          <div
                            className="bg-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                            style={{ width: "80px", height: "80px" }}
                          >
                            <span
                              className="material-symbols-outlined text-primary"
                              style={{ fontSize: "3rem" }}
                            >
                              cloud_upload
                            </span>
                          </div>
                          <h3 className="text-white fw-bold mb-2">
                            파일을 여기에 놓으세요
                          </h3>
                          <p className="text-white-50 mb-0">
                            드래그 앤 드롭으로 업로드
                          </p>
                        </div>
                      </div>
                    )}

                    <div className="mb-4">
                      <span
                        className="material-symbols-outlined text-primary mb-3"
                        style={{ fontSize: "4rem" }}
                      >
                        cloud_upload
                      </span>
                      <h4 className="fw-bold text-dark mb-2">
                        {isPhasedStatement ? "전체분 파일을 업로드하세요" : "파일을 업로드하세요"}
                      </h4>
                      <p className="text-muted mb-4">
                        {isPhasedStatement 
                          ? "차수분 내역서를 생성할 전체분 xlsx 파일을 선택하거나 여기에 끌어다 놓으세요"
                          : "xlsx 파일을 선택하거나 여기에 끌어다 놓으세요"}
                      </p>
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="selectFile"
                        className="btn btn-primary btn-lg px-4 py-3"
                      >
                        <span className="material-symbols-outlined me-2">
                          upload_file
                        </span>
                        파일 선택하기
                        <input
                          maxLength={100}
                          id="selectFile"
                          style={{ display: "none" }}
                          type="file"
                          accept=".xlsx"
                          name="files"
                          multiple
                          onChange={props.handleChangeFiles}
                        />
                      </label>
                    </div>

                    <div
                      className="alert alert-info mx-auto"
                      style={{ maxWidth: "400px" }}
                    >
                      <div className="d-flex align-items-start">
                        <span className="material-symbols-outlined text-info me-2 mt-1">
                          info
                        </span>
                        <div className="text-start">
                          <div className="fw-semibold text-info mb-1">
                            파일 업로드 안내
                          </div>
                          <ul className="mb-0 text-muted small">
                            <li>
                              최대 {props.fileCountLimit}개 파일까지 업로드 가능
                            </li>
                            <li>xlsx 확장자 지원</li>
                            <li><span style={{color: 'red', fontWeight: 'bold'}}>xls 등 다른 확장자는 엑셀을 열고
                              
                              [파일-<br/>다른 이름으로 저장-'엑셀통합문서(xlsx)'로 저장] 후 사용</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            {/* 기본 정보 설정 - 파일이 업로드된 경우 먼저 표시 */}
            {props.selectedItemId &&
              !isSafetyManagePlan &&
              !isEnviManagePlan &&
              !isPhasedStatement &&
              props.fileInfos.length > 0 && (
                <div
                  className="card shadow-sm mb-4"
                  style={{ border: "none", borderRadius: "16px" }}
                >
                  <div
                    className="card-header bg-white border-0 pt-4"
                    style={{ borderRadius: "16px 16px 0 0" }}
                  >
                    <h5 className="card-title mb-0 d-flex align-items-center">
                      <span
                        className={`material-symbols-outlined me-2 ${
                          props.requiresPreset(props.selectedItemId)
                            ? "text-info"
                            : "text-secondary"
                        }`}
                      >
                        {props.requiresPreset(props.selectedItemId)
                          ? "person_book"
                          : "settings_suggest"}
                      </span>
                      기본 정보 설정
                      {!props.requiresPreset(props.selectedItemId) && (
                        <span className="badge bg-light text-muted ms-2 small">
                          선택사항
                        </span>
                      )}
                    </h5>
                    <p className="text-muted mb-0 mt-2">
                      {props.requiresPreset(props.selectedItemId)
                        ? "서류 생성에 필요한 기본 정보를 설정해주세요."
                        : "필요시 기본 정보를 설정할 수 있습니다. (선택사항)"}
                    </p>
                  </div>
                  <div className="card-body">
                    <div className="row g-3">
                      {/* 회사정보 기본정보 */}
                      <div className="col-md-4">
                        <label className="form-label fw-semibold text-dark mb-2 d-flex align-items-center">
                          <span
                            className="material-symbols-outlined me-2"
                            style={{ fontSize: "16px" }}
                          >
                            business
                          </span>
                          회사정보
                        </label>
                        <div className="d-flex gap-2">
                          <select
                            className="form-select"
                            value={props.selectedPresets.companyInfo?.id || ""}
                            onChange={(e) => {
                              const preset = props.presets.find(
                                (p) =>
                                  p.id === e.target.value &&
                                  p.type === "companyInfo"
                              );
                              props.onSelectPreset("companyInfo", preset);
                            }}
                          >
                            <option value="">회사정보 선택</option>
                            {props.presets
                              .filter((p) => p.type === "companyInfo")
                              .map((preset) => (
                                <option key={preset.id} value={preset.id}>
                                  {preset.name}
                                </option>
                              ))}
                          </select>
                          {props.selectedPresets.companyInfo && (
                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm px-2"
                              onClick={() => {
                                props.onSelectPreset("companyInfo", undefined);
                                props.onClearDefaultPreset("companyInfo");
                              }}
                              title="선택 취소"
                            >
                              <span
                                className="material-symbols-outlined"
                                style={{ fontSize: "16px" }}
                              >
                                close
                              </span>
                            </button>
                          )}
                        </div>
                      </div>

                      {/* 현장대리인 기본정보 */}
                      <div className="col-md-4">
                        <label className="form-label fw-semibold text-dark mb-2 d-flex align-items-center">
                          <span
                            className="material-symbols-outlined me-2"
                            style={{ fontSize: "16px" }}
                          >
                            engineering
                          </span>
                          현장대리인
                        </label>
                        <div className="d-flex gap-2">
                          <select
                            className="form-select"
                            value={
                              props.selectedPresets.fieldRepresentative?.id ||
                              ""
                            }
                            onChange={(e) => {
                              const preset = props.presets.find(
                                (p) =>
                                  p.id === e.target.value &&
                                  p.type === "fieldRepresentative"
                              );
                              props.onSelectPreset(
                                "fieldRepresentative",
                                preset
                              );
                            }}
                            disabled={!props.selectedPresets.companyInfo}
                          >
                            <option value="">
                              {!props.selectedPresets.companyInfo
                                ? "회사정보를 먼저 선택하세요"
                                : "현장대리인 선택"}
                            </option>
                            {props.selectedPresets.companyInfo &&
                              props.presets
                                .filter(
                                  (p) =>
                                    p.type === "fieldRepresentative" &&
                                    String((p.data as any).companyId) ===
                                      props.selectedPresets.companyInfo?.id.split(
                                        "-"
                                      )[0]
                                )
                                .map((preset) => (
                                  <option key={preset.id} value={preset.id}>
                                    {preset.name}
                                  </option>
                                ))}
                          </select>
                          {props.selectedPresets.fieldRepresentative &&
                            props.selectedPresets.companyInfo && (
                              <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm px-2"
                                onClick={() => {
                                  props.onSelectPreset(
                                    "fieldRepresentative",
                                    undefined
                                  );
                                  props.onClearDefaultPreset(
                                    "fieldRepresentative"
                                  );
                                }}
                                title="선택 취소"
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{ fontSize: "16px" }}
                                >
                                  close
                                </span>
                              </button>
                            )}
                        </div>
                      </div>

                      {/* 공사정보 기본정보 */}
                      <div className="col-md-4">
                        <label className="form-label fw-semibold text-dark mb-2 d-flex align-items-center">
                          <span
                            className="material-symbols-outlined me-2"
                            style={{ fontSize: "16px" }}
                          >
                            construction
                          </span>
                          공사정보
                        </label>
                        <div className="d-flex gap-2">
                          <select
                            className="form-select"
                            value={
                              props.selectedPresets.projectInfo?.id ||
                              (props.requiresPreset(props.selectedItemId)
                                ? props.defaultPresets?.projectInfo?.id
                                : "") ||
                              ""
                            }
                            onChange={(e) => {
                              const preset = props.presets.find(
                                (p) =>
                                  p.id === e.target.value &&
                                  p.type === "projectInfo"
                              );
                              props.onSelectPreset("projectInfo", preset);
                            }}
                            disabled={!props.selectedPresets.companyInfo}
                          >
                            <option value="">
                              {!props.selectedPresets.companyInfo
                                ? "회사정보를 먼저 선택하세요"
                                : "공사정보 선택"}
                            </option>
                            {props.selectedPresets.companyInfo &&
                              props.presets
                                .filter(
                                  (p) =>
                                    p.type === "projectInfo" &&
                                    String((p.data as any).companyId) ===
                                      props.selectedPresets.companyInfo?.id.split(
                                        "-"
                                      )[0]
                                )
                                .map((preset) => (
                                  <option key={preset.id} value={preset.id}>
                                    {preset.name}
                                  </option>
                                ))}
                          </select>
                          {props.selectedPresets.projectInfo &&
                            props.selectedPresets.companyInfo && (
                              <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm px-2"
                                onClick={() => {
                                  props.onSelectPreset(
                                    "projectInfo",
                                    undefined
                                  );
                                  props.onClearDefaultPreset("projectInfo");
                                }}
                                title="선택 취소"
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{ fontSize: "16px" }}
                                >
                                  close
                                </span>
                              </button>
                            )}
                        </div>
                      </div>
                    </div>

                    {/* 선택된 기본정보 미리보기 */}
                    {(props.selectedPresets.fieldRepresentative ||
                      props.selectedPresets.companyInfo ||
                      props.selectedPresets.projectInfo) && (
                      <div className="mt-4 p-3 bg-light rounded-3">
                        <h6 className="fw-bold mb-2 text-dark d-flex align-items-center">
                          <span
                            className="material-symbols-outlined me-2"
                            style={{ fontSize: "16px" }}
                          >
                            preview
                          </span>
                          선택된 기본정보
                        </h6>
                        <div className="d-flex flex-wrap gap-2">
                          {props.selectedPresets.companyInfo && (
                            <span className="badge bg-warning text-dark">
                              <span
                                className="material-symbols-outlined me-1"
                                style={{ fontSize: "12px" }}
                              >
                                business
                              </span>
                              {props.selectedPresets.companyInfo.name}
                            </span>
                          )}
                          {props.selectedPresets.fieldRepresentative && (
                            <span className="badge bg-primary">
                              <span
                                className="material-symbols-outlined me-1"
                                style={{ fontSize: "12px" }}
                              >
                                engineering
                              </span>
                              {props.selectedPresets.fieldRepresentative.name}
                            </span>
                          )}
                          {props.selectedPresets.projectInfo && (
                            <span className="badge bg-success">
                              <span
                                className="material-symbols-outlined me-1"
                                style={{ fontSize: "12px" }}
                              >
                                construction
                              </span>
                              {props.selectedPresets.projectInfo.name}
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    {/* 기본정보관리 버튼 */}
                    <div className="mt-4 pt-3 border-top">
                      <div className="d-flex justify-content-between align-items-center">
                        <small className="text-muted">
                          <span
                            className="material-symbols-outlined me-1"
                            style={{ fontSize: "14px" }}
                          >
                            info
                          </span>
                          {props.requiresPreset(props.selectedItemId)
                            ? "기본 정보를 미리 설정하면 다음에 더 편리하게 사용할 수 있습니다."
                            : "기본 정보를 설정하면 향후 작업에서 자동으로 적용됩니다."}
                        </small>
                        <button
                          onClick={() =>
                            handleOpenPresetModalWithLoginCheck("companyInfo")
                          }
                          className="btn btn-outline-primary btn-sm d-flex align-items-center"
                        >
                          <span
                            className="material-symbols-outlined me-1"
                            style={{ fontSize: "16px" }}
                          >
                            bookmark_manager
                          </span>
                          기본정보관리
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

            {/* 파일이 업로드된 경우의 컨텐츠 */}
            {props.fileInfos.length > 0 &&
              !isPresetBasedItem(props.selectedItemId) &&
              !isEnviManagePlan && (
                <div
                  className="position-relative mb-4"
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                >
                  {/* 드래그 오버레이 */}
                  {dragOver && (
                    <div
                      className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                      style={{
                        backgroundColor: "rgba(13, 110, 253, 0.85)",
                        zIndex: 1000,
                        borderRadius: "16px",
                        border: "4px dashed #ffffff",
                        backdropFilter: "blur(2px)",
                      }}
                    >
                      <div className="text-center">
                        <div
                          className="bg-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                          style={{ width: "80px", height: "80px" }}
                        >
                          <span
                            className="material-symbols-outlined text-primary"
                            style={{ fontSize: "3rem" }}
                          >
                            cloud_upload
                          </span>
                        </div>
                        <h3 className="text-white fw-bold mb-2">
                          파일을 여기에 놓으세요
                        </h3>
                        <p className="text-white-50 mb-0">
                          드래그 앤 드롭으로 업로드
                        </p>
                      </div>
                    </div>
                  )}

                  <div
                    className="card shadow-sm"
                    style={{ border: "none", borderRadius: "16px" }}
                  >
                    <div
                      className="card-header bg-white border-0 pt-4"
                      style={{ borderRadius: "16px 16px 0 0" }}
                    >
                      <h5 className="card-title mb-0 d-flex align-items-center">
                        <span className="material-symbols-outlined me-2 text-success">
                          folder_open
                        </span>
                        업로드된 파일
                        <span className="badge bg-primary rounded-pill ms-2">
                          {props.fileInfos.length}/{props.fileCountLimit}
                        </span>
                      </h5>
                    </div>
                    <div className="card-body">
                      {/* 선급금 입력 - 기성내역서만 */}
                      {isProgressReportItem(props.selectedItemId) && (
                        <div className="mb-4 p-3 bg-light rounded-3">
                          <div className="mb-3">
                            <h6 className="fw-bold mb-2 text-dark d-flex align-items-center">
                              <span
                                className="material-symbols-outlined me-2 text-warning"
                                style={{ fontSize: "18px" }}
                              >
                                account_balance_wallet
                              </span>
                              선급금 입력
                            </h6>
                            <small className="text-muted">
                              기성내역서 작성에 사용할 선급금 금액을 입력하세요
                            </small>
                          </div>
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              value={props.advancePayment}
                              onChange={(e) => {
                                const value = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                ); // 숫자만 추출
                                const formattedValue = value
                                  ? Number(value).toLocaleString("ko-KR")
                                  : "";
                                props.handleAdvancePaymentChange(
                                  formattedValue
                                );
                              }}
                              placeholder="선급금 금액을 입력하세요"
                              style={{
                                borderRadius: "8px 0 0 8px",
                                fontSize: "14px",
                              }}
                            />
                            <span
                              className="input-group-text"
                              style={{
                                borderRadius: "0 8px 8px 0",
                                fontSize: "14px",
                                backgroundColor: "#f8f9fa",
                              }}
                            >
                              원
                            </span>
                          </div>
                        </div>
                      )}

                      <div
                        className="table-responsive"
                        style={{
                          maxHeight: "400px",
                          overflowY: "auto",
                        }}
                      >
                        <table className="table table-hover align-middle">
                          <thead className="table-light">
                            <tr>
                              <th scope="col" className="border-0">
                                파일명
                              </th>
                              <th scope="col" className="border-0 text-center">
                                <div className="d-flex align-items-center justify-content-center">
                                  시트 목록
                                </div>
                              </th>
                              <th scope="col" className="border-0 text-center">
                                작업
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {props.fileInfos.map((file, fileIndex) => {
                              const selectedCount =
                                getSelectedSheetsCount(file);
                              const totalCount =
                                getTotalVisibleSheetsCount(file);
                              const isExpanded =
                                props.expandedFiles.has(fileIndex);

                              return (
                                <React.Fragment key={fileIndex}>
                                  <tr className="border-0">
                                    <td>
                                      <div className="d-flex align-items-center">
                                        <span className="material-symbols-outlined text-success me-2">
                                          description
                                        </span>
                                        <div className="flex-grow-1">
                                          <div
                                            className="fw-semibold text-dark"
                                            title={file.name}
                                          >
                                            {file.name.length > 40
                                              ? `${file.name.substring(
                                                  0,
                                                  40
                                                )}...`
                                              : file.name}
                                          </div>
                                          <small className="text-muted">
                                            {(file.size / 1024 / 1024).toFixed(
                                              2
                                            )}{" "}
                                            MB
                                          </small>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="text-center">
                                      <div className="d-flex align-items-center justify-content-center">
                                        <button
                                          className="btn btn-outline-primary btn-sm"
                                          onClick={() =>
                                            toggleFileExpanded(fileIndex)
                                          }
                                        >
                                          <span
                                            className="material-symbols-outlined me-1"
                                            style={{ fontSize: "16px" }}
                                          >
                                            {isExpanded
                                              ? "expand_less"
                                              : "expand_more"}
                                          </span>
                                          {isExpanded ? "접기" : "시트 선택"}
                                          <span className="badge bg-info ms-2">
                                            {selectedCount}/{totalCount}
                                          </span>
                                        </button>
                                      </div>
                                    </td>
                                    <td className="text-center">
                                      <div className="d-flex justify-content-center">
                                        <button
                                          onClick={props.handleDelete(
                                            fileIndex
                                          )}
                                          className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "32px",
                                            height: "32px",
                                          }}
                                        >
                                          <Close fontSize="small" />
                                        </button>
                                      </div>
                                    </td>
                                  </tr>

                                  {/* 시트 선택 확장 영역 */}
                                  {isExpanded && (
                                    <tr>
                                      <td colSpan={3}>
                                        <div className="p-3 bg-light rounded">
                                          <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h6 className="mb-0 fw-semibold">
                                              시트 선택
                                            </h6>
                                            <div className="btn-group btn-group-sm">
                                              <button
                                                className="btn btn-outline-success"
                                                onClick={() => {
                                                  file.sheets?.forEach(
                                                    (sheet) => {
                                                      if (
                                                        !sheet.checked &&
                                                        (props.isHiddenSheetShow ||
                                                          !sheet.isHidden)
                                                      ) {
                                                        props.handleSheetClick(
                                                          fileIndex,
                                                          sheet
                                                        );
                                                      }
                                                    }
                                                  );
                                                }}
                                              >
                                                전체 선택
                                              </button>
                                              <button
                                                className="btn btn-outline-secondary"
                                                onClick={() => {
                                                  file.sheets?.forEach(
                                                    (sheet) => {
                                                      if (sheet.checked) {
                                                        props.handleSheetClick(
                                                          fileIndex,
                                                          sheet
                                                        );
                                                      }
                                                    }
                                                  );
                                                }}
                                              >
                                                전체 해제
                                              </button>
                                            </div>
                                          </div>
                                          <div
                                            className="row g-2"
                                            style={{
                                              maxHeight: "200px",
                                              overflowY: "auto",
                                            }}
                                          >
                                            {file?.sheets
                                              ?.filter((sheet) =>
                                                props.isHiddenSheetShow
                                                  ? true
                                                  : !sheet.isHidden
                                              )
                                              ?.map((sheet) => (
                                                <div
                                                  key={sheet.sheetIndex}
                                                  className="col-md-6"
                                                >
                                                  <div
                                                    className={`card border ${
                                                      sheet.checked
                                                        ? "border-primary bg-primary bg-opacity-10"
                                                        : "border-secondary"
                                                    } ${
                                                      sheet.isHidden
                                                        ? "opacity-75"
                                                        : ""
                                                    }`}
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      props.handleSheetClick(
                                                        fileIndex,
                                                        sheet
                                                      )
                                                    }
                                                  >
                                                    <div className="card-body p-2">
                                                      <div className="d-flex align-items-center">
                                                        <input
                                                          className="form-check-input me-3"
                                                          type="checkbox"
                                                          checked={
                                                            sheet.checked
                                                          }
                                                          onChange={() => {}}
                                                          style={{
                                                            pointerEvents:
                                                              "none",
                                                            margin: 0,
                                                            verticalAlign:
                                                              "middle",
                                                          }}
                                                        />
                                                        <div className="flex-grow-1">
                                                          <div
                                                            className={`fw-semibold ${
                                                              sheet.checked
                                                                ? "text-primary"
                                                                : "text-dark"
                                                            }`}
                                                            title={sheet.name}
                                                            style={{
                                                              lineHeight: "1.2",
                                                            }}
                                                          >
                                                            {sheet.name.length >
                                                            20
                                                              ? `${sheet.name.substring(
                                                                  0,
                                                                  20
                                                                )}...`
                                                              : sheet.name}
                                                          </div>
                                                          {sheet.estimatedSecondsX2 != null && sheet.estimatedSecondsX2 >= 60 && (
                                                            <div
                                                              className={`small ${sheet.estimatedSecondsX2 >= (sheet.maxJobSeconds || 3600) ? "text-danger fw-semibold" : sheet.estimatedSecondsX2 >= 600 ? "text-warning" : "text-muted"}`}
                                                              style={{ fontSize: "11px", lineHeight: "1.2" }}
                                                              title={`수식 ${sheet.formulas ?? "-"}개 · 병합 ${sheet.merges ?? "-"}개 · 행 ${sheet.lastRow}`}
                                                            >
                                                              예상 {formatEtaKo(sheet.estimatedSecondsX2)}
                                                              {NON_STATEMENT_SHEET.test(sheet.name) ? " · 내역서 아닐 수 있음" : ""}
                                                            </div>
                                                          )}
                                                        </div>
                                                        {sheet.isHidden && (
                                                          <span
                                                            className="material-symbols-outlined text-muted ms-2"
                                                            style={{
                                                              fontSize: "18px",
                                                            }}
                                                            title="숨겨진 시트"
                                                          >
                                                            visibility_off
                                                          </span>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ))}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      {/* 파일 추가 버튼 */}
                      {props.fileInfos.length < props.fileCountLimit && (
                        <div className="mt-3 pt-3 border-top">
                          <label
                            htmlFor="selectFile2"
                            className="btn btn-outline-primary d-flex align-items-center justify-content-center w-100 py-3"
                          >
                            <span className="material-symbols-outlined me-2">
                              add_circle
                            </span>
                            파일 더 추가하기
                            <input
                              maxLength={100}
                              id="selectFile2"
                              style={{ display: "none" }}
                              type="file"
                              accept=".xlsx"
                              name="files"
                              multiple
                              onChange={props.handleChangeFiles}
                            />
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

            {/* 차수분 내역서 - 파일이 업로드된 경우에만 차수 설정 표시 */}
            {isPhasedStatement && props.fileInfos.length > 0 && (
              <div className="mt-4">
                {/* 차수 설정 섹션 */}
                <div className="card shadow-sm mb-4" style={{ border: "none", borderRadius: "16px" }}>
                  <div className="card-header bg-white border-0 pt-4 pb-3" style={{ borderRadius: "16px 16px 0 0" }}>
                    <h5 className="fw-bold text-dark mb-0">차수 설정</h5>
                  </div>
                  <div className="card-body px-4 pb-4">
                    {/* 차수 개수 설정 */}
                    <div className="mb-4">
                      <label className="form-label fw-semibold text-dark mb-3">차수 개수</label>
                      <div className="d-flex align-items-center">
                        <button 
                          className="btn btn-outline-secondary" 
                          type="button"
                          onClick={() => props.onPhaseCountChange(Math.max(1, props.phaseCount - 1))}
                          disabled={props.phaseCount <= 1}
                          style={{ borderRadius: "8px 0 0 8px" }}
                        >
                          <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                            remove
                          </span>
                        </button>
                        <input 
                          type="number" 
                          className="form-control text-center" 
                          value={props.phaseCount}
                          onChange={(e) => props.onPhaseCountChange(Math.max(1, parseInt(e.target.value) || 1))}
                          min="1" 
                          max="10"
                          style={{ maxWidth: "80px", borderRadius: "0" }}
                        />
                        <button 
                          className="btn btn-outline-secondary" 
                          type="button"
                          onClick={() => props.onPhaseCountChange(Math.min(10, props.phaseCount + 1))}
                          disabled={props.phaseCount >= 10}
                          style={{ borderRadius: "0 8px 8px 0" }}
                        >
                          <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                            add
                          </span>
                        </button>
                      </div>
                    </div>

                    {/* 차수별 텍스트 입력 - 세로 레이아웃 */}
                    <div>
                      <label className="form-label fw-semibold text-dark mb-3">차수별 텍스트</label>
                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex align-items-center">
                          <span className="text-muted me-3" style={{ minWidth: "60px" }}>전체:</span>
                          <input 
                            type="text" 
                            className="form-control" 
                            style={{ maxWidth: "200px" }}
                            value={props.totalText}
                            onChange={(e) => props.onTotalTextChange(e.target.value)}
                            placeholder="전체"
                          />
                        </div>
                        {props.phaseTexts.map((text, index) => (
                          <div key={index} className="d-flex align-items-center">
                            <span className="text-muted me-3" style={{ minWidth: "60px" }}>{index + 1}차:</span>
                            <input 
                              type="text" 
                              className="form-control" 
                              style={{ maxWidth: "200px" }}
                              value={text}
                              onChange={(e) => {
                                const newTexts = [...props.phaseTexts];
                                newTexts[index] = e.target.value;
                                props.onPhaseTextsChange(newTexts);
                              }}
                              placeholder={`${index + 1}차`}
                            />
                          </div>
                        ))}
                        <div className="d-flex align-items-center">
                          <span className="text-muted me-3" style={{ minWidth: "60px" }}>잔여:</span>
                          <input 
                            type="text" 
                            className="form-control" 
                            style={{ maxWidth: "200px" }}
                            value={props.remainderText}
                            onChange={(e) => props.onRemainderTextChange(e.target.value)}
                            placeholder="잔여"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* 실행 옵션 - 파일이 업로드된 경우에만 표시 */}
            {props.fileInfos.length > 0 &&
              !isSafetyManagePlan &&
              !isEnviManagePlan && (
                <div
                  className="card shadow-sm"
                  style={{ border: "none", borderRadius: "16px" }}
                >
                  <div
                    className="card-header bg-white border-0 pt-4"
                    style={{ borderRadius: "16px 16px 0 0" }}
                  >
                    <h5 className="card-title mb-0 d-flex align-items-center">
                      <span className="material-symbols-outlined me-2 text-warning">
                        settings
                      </span>
                      실행 옵션
                    </h5>
                  </div>
                  <div className="card-body">
                    {/* 기타 실행 옵션들 */}
                    <div className="d-flex flex-column gap-3">
                      {/* 차수분 내역서 실행 옵션 */}
                      {isPhasedStatement && (
                        <div>
                          {/* 1차가 아닌 경우에만 업로드 방식 선택 옵션 표시 */}
                          {props.phaseCount > 1 && (
                            <>
                              <div className="mb-2">
                                <span className="fw-semibold text-dark me-2 small">
                                  파일 업로드 방식
                                </span>
                              </div>
                              <div className="d-flex gap-2">
                                <div
                                  className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                    props.useExistingFiles
                                      ? "bg-primary text-white"
                                      : "bg-white"
                                  }`}
                                  onClick={() => props.onUseExistingFilesChange(true)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <span className="fw-semibold small">차수 파일 업로드</span>
                                  <p className="text-small mb-0 mt-1" style={{ fontSize: "12px", opacity: 0.8 }}>
                                    각 차수별로 개별 파일을 업로드하여 내역서를 생성합니다
                                  </p>
                                </div>
                                <div
                                  className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                    !props.useExistingFiles
                                      ? "bg-primary text-white"
                                      : "bg-white"
                                  }`}
                                  onClick={() => props.onUseExistingFilesChange(false)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <span className="fw-semibold small">전체분 파일만 업로드</span>
                                  <p className="text-small mb-0 mt-1" style={{ fontSize: "12px", opacity: 0.8 }}>
                                    전체분 파일을 기반으로 차수별 내역서를 자동 생성합니다
                                  </p>
                                </div>
                              </div>
                            </>
                          )}

                          {/* 차수별 파일 업로드 - 차수 파일 업로드 옵션 선택 시 && 1차가 아닌 경우에만 표시 */}
                          {props.useExistingFiles && props.phaseCount > 1 && (
                            <div className="mt-3 border rounded p-3" style={{ backgroundColor: "#f8f9fa" }}>
                              <h6 className="fw-bold text-dark mb-3">차수별 파일 업로드</h6>
                              {Array.from({ length: props.phaseCount - 1 }, (_, index) => {
                                const phase = index + 1;
                                const phaseFile = props.phaseFiles.find(pf => pf.phase === phase);
                                const phaseFileIndex = props.phaseFiles.findIndex(pf => pf.phase === phase);
                                
                                return (
                                  <div key={phase} className="mb-3">
                                    <div className="d-flex align-items-center mb-2">
                                      <span className="fw-semibold me-3" style={{ minWidth: "100px" }}>{props.phaseTexts[index]} 파일:</span>
                                      <input 
                                        ref={(el) => (props.phaseFileInputRefs.current[phase] = el)}
                                        type="file" 
                                        accept=".xlsx,.xls"
                                        className="form-control" 
                                        style={{ maxWidth: "300px" }}
                                        onChange={(e) => props.onPhaseFileChange(e, phase)}
                                      />
                                      {phaseFile && (
                                        <button 
                                          className="btn btn-sm btn-outline-danger ms-2"
                                          onClick={() => props.onDeletePhaseFile(phase)}
                                          title="파일 삭제"
                                        >
                                          <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>
                                            delete
                                          </span>
                                        </button>
                                      )}
                                    </div>
                                    
                                    {phaseFile && (
                                      <div className="ms-5">
                                        <small className="text-muted">{phaseFile.file.name}</small>
                                        <div className="text-info mt-1">
                                          <small>
                                            <span className="material-symbols-outlined" style={{ fontSize: "14px", verticalAlign: "text-bottom" }}>
                                              info
                                            </span>
                                            전체분에서 선택한 시트가 자동으로 적용됩니다
                                          </small>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      )}
                      {/* 갑지 선택 옵션 - 두 줄로 나누기, 변경 준공만들기 */}
                      {(props.selectedItemId === "change-3" ||
                        props.selectedItemId === "change-4") && (
                        <div>
                          <div className="mb-2">
                            <span className="fw-semibold text-dark me-2 small">
                              갑지 선택
                            </span>
                            <span
                              className="text-muted"
                              style={{
                                cursor: "help",
                                fontSize: "14px",
                                position: "relative",
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="갑지를 생성할지 선택하는 옵션입니다"
                              title="갑지를 생성할지 선택하는 옵션입니다"
                            >
                              <QuestionCircleOutlined />
                            </span>
                          </div>
                          <div className="d-flex gap-2">
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                props.gapjiOption === "없음"
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() => props.handleOnGapjiChange("없음")}
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">없음</span>
                            </div>
                            {props.selectedItemId === "change-3" && (
                              <div
                                className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                  props.gapjiOption === "change"
                                    ? "bg-primary text-white"
                                    : "bg-white"
                                }`}
                                onClick={() =>
                                  props.handleOnGapjiChange("change")
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <span className="fw-semibold small">
                                  변경갑지
                                </span>
                              </div>
                            )}
                            {(props.selectedItemId === "change-4" ||
                              props.selectedItemId === "completion-1") && (
                              <div
                                className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                  props.gapjiOption === "complete"
                                    ? "bg-primary text-white"
                                    : "bg-white"
                                }`}
                                onClick={() =>
                                  props.handleOnGapjiChange("complete")
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <span className="fw-semibold small">
                                  준공갑지
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {/* 나누기 방향 설정 - 두줄로 나누기, 준공내역서 */}
                      {(props.selectedItemId === "change-3" ||
                        props.selectedItemId === "completion-1") && (
                        <div>
                          <div className="mb-2">
                            <span className="fw-semibold text-dark me-2 small">
                              나누기 방향 설정
                            </span>
                            <span
                              className="text-muted"
                              style={{
                                cursor: "help",
                                fontSize: "14px",
                                position: "relative",
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="두 줄로 나눌 때의 방향을 설정하는 옵션입니다"
                              title="두 줄로 나눌 때의 방향을 설정하는 옵션입니다"
                            >
                              <QuestionCircleOutlined />
                            </span>
                          </div>
                          <div className="d-flex gap-2">
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                props.divideDirectionOption === "vertical"
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() =>
                                props.handleOnDivideDirectionChange("vertical")
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">세로</span>
                            </div>
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                props.divideDirectionOption === "horizontal"
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() =>
                                props.handleOnDivideDirectionChange(
                                  "horizontal"
                                )
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">가로</span>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* 당초 흑서/적서 여부 */}
                      {(props.selectedItemId === "change-3" ||
                        props.selectedItemId === "change-2" ||
                        props.selectedItemId === "change-1" ||
                        props.selectedItemId === "change-6" ||
                        props.selectedItemId === "change-7" ||
                        props.selectedItemId === "completion-1") && (
                        <div>
                          <div className="mb-2">
                            <span className="fw-semibold text-dark me-2 small">
                              당초 흑서/적서 여부
                            </span>
                            <span
                              className="text-muted"
                              style={{
                                cursor: "help",
                                fontSize: "14px",
                                position: "relative",
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="흑서: 일반적인 문서 형태, 적서: 수정사항이 표시된 문서 형태"
                              title="흑서: 일반적인 문서 형태, 적서: 수정사항이 표시된 문서 형태"
                            >
                              <QuestionCircleOutlined />
                            </span>
                          </div>
                          <div className="d-flex gap-2">
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                props.originOption === "black"
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() =>
                                props.handleOnOriginChange("black")
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">흑서</span>
                            </div>
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                props.originOption === "red"
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() => props.handleOnOriginChange("red")}
                              style={{ cursor: "pointer" }}
                            >
                              <span
                                className={`fw-semibold small ${
                                  props.originOption === "red"
                                    ? "text-white"
                                    : "text-danger"
                                }`}
                              >
                                적서
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* 행고정 인식 여부 */}
                      {(props.selectedItemId === "change-3" ||
                        props.selectedItemId === "change-4" ||
                        props.selectedItemId === "change-5" ||
                        props.selectedItemId === "change-6" ||
                        props.selectedItemId === "completion-1") && (
                        <div>
                          <div className="mb-2">
                            <span className="fw-semibold text-dark me-2 small">
                              행고정 인식 여부
                            </span>
                            <span
                              className="text-muted"
                              style={{
                                cursor: "help",
                                fontSize: "14px",
                                position: "relative",
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="시트에 행고정이 되어있다면 그 이후부터 실행할지, 시트 전체를 실행할지 선택하는 옵션입니다"
                              title="시트에 행고정이 되어있다면 그 이후부터 실행할지, 시트 전체를 실행할지 선택하는 옵션입니다"
                            >
                              <QuestionCircleOutlined />
                            </span>
                          </div>
                          <div className="d-flex gap-2">
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                props.divideOption === "fixed"
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() =>
                                props.handleOnDivideChange("fixed")
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">
                                행고정 이후
                              </span>
                            </div>
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                props.divideOption === "all"
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() => props.handleOnDivideChange("all")}
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">
                                시트 전체
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* 변경행 위치 설정 */}
                      {(props.selectedItemId === "change-3" ||
                        props.selectedItemId === "change-2" ||
                        props.selectedItemId === "change-1" ||
                        props.selectedItemId === "change-4" ||
                        props.selectedItemId === "change-7" ||
                        props.selectedItemId === "completion-1") && (
                        <div>
                          <div className="mb-2">
                            <span className="fw-semibold text-dark me-2 small">
                              변경행 위치 설정
                            </span>
                            <span
                              className="text-muted"
                              style={{
                                cursor: "help",
                                fontSize: "14px",
                                position: "relative",
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="수식이 연결되어 있는 행 위치를 아래쪽으로 할지, 위쪽으로 할지 선택하는 옵션입니다"
                              title="수식이 연결되어 있는 행 위치를 아래쪽으로 할지, 위쪽으로 할지 선택하는 옵션입니다"
                            >
                              <QuestionCircleOutlined />
                            </span>
                          </div>
                          <div className="d-flex gap-2">
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                props.originRowOption
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() =>
                                props.handleOnOriginRowChange(true)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">
                                하단으로
                              </span>
                            </div>
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                !props.originRowOption
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() =>
                                props.handleOnOriginRowChange(false)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">
                                상단으로
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* 두줄 나누기: 당초 줄 수식 유지 옵션 (기본 꺼짐 = 값) */}
                      {(props.selectedItemId === "change-3" ||
                        props.selectedItemId === "completion-1") &&
                        props.onKeepOriginFormulasChange && (
                        <div>
                          <div className="mb-2 d-flex align-items-center">
                            <span className="fw-semibold text-dark me-2 small">당초 줄 내용</span>
                            <span
                              className="text-muted"
                              style={{ cursor: "help", fontSize: "14px", position: "relative" }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="값: 당초 줄을 숫자로 고정합니다(기본). 수식 유지: 당초 줄에도 변경 줄과 같은 수식을 넣되 당초끼리만 참조합니다. 단가·일위대가처럼 나누지 않은 시트를 고치면 당초도 따라 바뀝니다."
                              title="값: 당초 줄을 숫자로 고정합니다(기본). 수식 유지: 당초 줄에도 변경 줄과 같은 수식을 넣되 당초끼리만 참조합니다. 단가·일위대가처럼 나누지 않은 시트를 고치면 당초도 따라 바뀝니다."
                            >
                              <QuestionCircleOutlined />
                            </span>
                          </div>
                          <div className="d-flex gap-2">
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                !props.keepOriginFormulas ? "bg-primary text-white" : "bg-white"
                              }`}
                              onClick={() => props.onKeepOriginFormulasChange!(false)}
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">값으로 고정</span>
                              <p className="text-small mb-0 mt-1" style={{ fontSize: "12px", opacity: 0.8 }}>
                                당초 줄은 숫자만 남습니다 (기본)
                              </p>
                            </div>
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                props.keepOriginFormulas ? "bg-primary text-white" : "bg-white"
                              }`}
                              onClick={() => props.onKeepOriginFormulasChange!(true)}
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">수식 유지</span>
                              <p className="text-small mb-0 mt-1" style={{ fontSize: "12px", opacity: 0.8 }}>
                                당초 줄도 수식, 당초끼리만 참조
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* 증감내역서 분리 컬럼 옵션 (change-2 / change-7 공용) */}
                      {(props.selectedItemId === "change-2" ||
                        props.selectedItemId === "change-7") && (
                        <div>
                          <div className="mb-2">
                            <span className="fw-semibold text-dark me-2 small">
                              양식 선택
                            </span>
                            <span
                              className="text-muted"
                              style={{
                                cursor: "help",
                                fontSize: "14px",
                              }}
                              title="기본형: 기존 증감내역서 양식. 분리형: 수량/금액 각각 당초·변경·증(+)·감(-) 4열로 분리된 공사비물량대비표/공사비증감대비표 양식."
                            >
                              <QuestionCircleOutlined />
                            </span>
                          </div>
                          <div className="d-flex gap-2">
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                !props.useSeparatedColumns
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() =>
                                props.onUseSeparatedColumnsChange(false)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">
                                기본형
                              </span>
                            </div>
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                props.useSeparatedColumns
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() =>
                                props.onUseSeparatedColumnsChange(true)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">
                                분리형 (증/감 분리)
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* 삭제행 위치 설정 */}
                      {props.selectedItemId === "change-5" && (
                        <div>
                          <div className="mb-2">
                            <span className="fw-semibold text-dark me-2 small">
                              삭제행 위치 설정
                            </span>
                            <span
                              className="text-muted"
                              style={{
                                cursor: "help",
                                fontSize: "14px",
                                position: "relative",
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="두줄 중 하나를 삭제할 때 삭제할 행 위치를 선택하는 옵션입니다"
                              title="두줄 중 하나를 삭제할 때 삭제할 행 위치를 선택하는 옵션입니다"
                            >
                              <QuestionCircleOutlined />
                            </span>
                          </div>
                          <div className="d-flex gap-2">
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                props.originRowOption
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() =>
                                props.handleOnOriginRowChange(true)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">
                                위쪽 삭제
                              </span>
                            </div>
                            <div
                              className={`flex-grow-1 p-2 border rounded-3 cursor-pointer text-center ${
                                !props.originRowOption
                                  ? "bg-primary text-white"
                                  : "bg-white"
                              }`}
                              onClick={() =>
                                props.handleOnOriginRowChange(false)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <span className="fw-semibold small">
                                아래쪽 삭제
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* 준공정산금액 입력 - 준공계서류, 청구서류만 */}
                      {isCompletionSettlementItem(props.selectedItemId) && (
                        <div>
                          <div className="mb-2">
                            <span className="fw-semibold text-dark me-2 small">
                              준공정산금액 입력
                            </span>
                            <span
                              className="text-muted"
                              style={{
                                cursor: "help",
                                fontSize: "14px",
                                position: "relative",
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="준공계서류 및 청구서류 작성에 사용할 준공정산금액을 입력하세요"
                              title="준공계서류 및 청구서류 작성에 사용할 준공정산금액을 입력하세요"
                            >
                              <QuestionCircleOutlined />
                            </span>
                          </div>
                          <div className="p-2 border rounded-3 bg-white">
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                value={props.completionSettlementAmount}
                                onChange={(e) => {
                                  const value = e.target.value.replace(
                                    /[^0-9]/g,
                                    ""
                                  ); // 숫자만 추출
                                  const formattedValue = value
                                    ? Number(value).toLocaleString("ko-KR")
                                    : "";
                                  props.handleCompletionSettlementAmountChange(
                                    formattedValue
                                  );
                                }}
                                placeholder="준공정산금액을 입력하세요"
                                style={{
                                  borderRadius: "6px 0 0 6px",
                                  fontSize: "13px",
                                }}
                              />
                              <span
                                className="input-group-text"
                                style={{
                                  borderRadius: "0 6px 6px 0",
                                  fontSize: "13px",
                                }}
                              >
                                원
                              </span>
                            </div>
                            <small className="text-muted d-block mt-1">
                              <span
                                className="material-symbols-outlined me-1"
                                style={{ fontSize: "12px" }}
                              >
                                info
                              </span>
                              준공계서류 및 청구서류에 반영할 정산금액을
                              입력하세요
                            </small>
                          </div>
                        </div>
                      )}

                      {/* 숨겨진 시트 표시 - 모든 기능에 공통 */}
                      <div>
                        <div className="mb-2">
                          <span className="fw-semibold text-dark me-2 small">
                            숨겨진 시트 표시
                          </span>
                          <span
                            className="text-muted"
                            style={{
                              cursor: "help",
                              fontSize: "14px",
                              position: "relative",
                            }}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="Excel 파일에서 숨겨진 시트를 표시하거나 숨김 처리할지 선택합니다"
                            title="Excel 파일에서 숨겨진 시트를 표시하거나 숨김 처리할지 선택합니다"
                          >
                            <QuestionCircleOutlined />
                          </span>
                        </div>
                        <div
                          className={`p-2 border rounded-3 cursor-pointer transition-all text-center ${
                            props.isHiddenSheetShow
                              ? "bg-primary text-white border-primary"
                              : "bg-white border-light hover:border-primary"
                          }`}
                          onClick={props.handleHiddenSheetClick}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="d-flex align-items-center justify-content-center">
                            <span
                              className="material-symbols-outlined me-2"
                              style={{ fontSize: "16px" }}
                            >
                              {props.isHiddenSheetShow
                                ? "visibility"
                                : "visibility_off"}
                            </span>
                            <span className="fw-semibold small">
                              {props.isHiddenSheetShow ? "숨기기" : "표시"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 예상 처리 시간·한도 안내 (서버가 시트별로 계산: 행·수식·병합·이름정의 반영) */}
                    {(() => {
                      const eta = sumX2Eta(props.fileInfos);
                      if (eta.selectedSheets === 0) return null;
                      const over = eta.seconds >= eta.maxJobSeconds;
                      const heavy = eta.seconds >= eta.maxJobSeconds * 0.5;
                      const nonStatementChecked = props.fileInfos.some((f) =>
                        (f.sheets || []).some((sh) => sh.checked && NON_STATEMENT_SHEET.test(sh.name))
                      );
                      const split = over ? adviseX2Split(props.fileInfos) : null;
                      return (
                        <div
                          className={`mt-4 p-3 rounded-3 border ${over ? "border-danger bg-danger bg-opacity-10" : heavy ? "border-warning bg-warning bg-opacity-10" : "border-secondary bg-light"}`}
                        >
                          <div className="d-flex align-items-center">
                            <span className="material-symbols-outlined me-2" style={{ fontSize: "18px" }}>
                              {over ? "error" : heavy ? "warning" : "schedule"}
                            </span>
                            <span className={`fw-semibold ${over ? "text-danger" : heavy ? "text-warning" : "text-dark"}`}>
                              선택한 시트 {eta.selectedSheets}개 · 예상 처리 시간 {eta.seconds > 0 ? formatEtaKo(eta.seconds) : "계산 불가"}
                              {eta.unknownSheets > 0 ? ` (통계 없는 시트 ${eta.unknownSheets}개 제외)` : ""}
                            </span>
                          </div>
                          {over && (
                            <div className="small mt-2 text-danger">
                              작업 하나는 최대 {formatEtaKo(eta.maxJobSeconds).replace("약 ", "")}까지만 처리됩니다. 이대로 실행하면 접수 단계에서 거절되거나 중간에 중단됩니다.
                              {split && split.batchSize > 0 && (
                                <>
                                  {" "}시트를 <b>{split.batchSize}개씩 나눠 {split.runs}번</b>에 걸쳐 실행하면 전부 처리할 수 있습니다. 한 번 실행한 뒤 같은 파일을 다시 올려 다음 시트들을 고르면 됩니다.
                                </>
                              )}
                              {split && split.batchSize === 0 && (
                                <>
                                  {" "}<b>'{split.blockingSheet}'</b> 시트는 하나만으로도 한도를 넘습니다. 그 시트의 도형·그림을 지우거나 스크롤 범위를 정리한 사본을 올려 주세요(실패 작업의 '조치 방법' 참고).
                                </>
                              )}
                              {!split && <> 두 줄로 나눌 <b>내역서 시트만</b> 선택하거나, 공종별로 나눠 여러 번 실행해 주세요.</>}
                            </div>
                          )}
                          {!over && heavy && (
                            <div className="small mt-2 text-warning">
                              처리 시간이 길어질 수 있습니다. 내역서 시트만 선택하면 빨라집니다.
                            </div>
                          )}
                          {eta.heaviest.length > 0 && (over || heavy) && (
                            <div className="small mt-1 text-muted">
                              오래 걸리는 시트: {eta.heaviest.map((h) => `${h.name}(${formatEtaKo(h.seconds)})`).join(", ")}
                            </div>
                          )}
                          {over && split && split.batchSize > 0 && props.handleKeepSheetsWithinLimit && (
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger mt-2 me-2"
                              onClick={props.handleKeepSheetsWithinLimit}
                            >
                              한도에 맞춰 앞쪽 시트만 남기기 (1번째 묶음)
                            </button>
                          )}
                          {(over || heavy) && nonStatementChecked && props.handleUncheckNonStatementSheets && (
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-secondary mt-2"
                              onClick={props.handleUncheckNonStatementSheets}
                            >
                              일위대가·단가산출·수량산출 등 내역서가 아닌 시트 선택 해제
                            </button>
                          )}
                        </div>
                      );
                    })()}

                    {/* 실행 버튼 */}
                    <div className="mt-4">
                      <button
                        onClick={isPhasedStatement ? props.onPhasedStatementExecution : props.handleExecute}
                        className="btn btn-primary w-100 py-3"
                        style={{ borderRadius: "12px" }}
                      >
                        <span className="material-symbols-outlined me-2">
                          play_circle
                        </span>
                        실행하기
                      </button>
                    </div>
                  </div>
                </div>
              )}

            {/* 안전관리비 사용계획 폼 - 해당 항목이 선택되었을 때만 표시 */}
            {isSafetyManagePlan && (
              <UsagePlanForm
                selectedItemId={props.selectedItemId}
                selectedPresets={props.selectedPresets}
                presets={props.presets}
                usagePlan={props.safetyManagePlan}
                onUsagePlanChange={props.onSafetyManagePlanChange}
                onSelectPreset={props.onSelectPreset}
                onOpenPresetModal={props.onOpenPresetModal}
                onDocumentGenerate={props.onDocumentGenerate}
                title={
                  props.selectedItemId === "start-2-2"
                    ? "안전관리비 사용계획서"
                    : "안전관리비 사용내역서"
                }
                description={
                  props.selectedItemId === "start-2-2"
                    ? "안전관리비 사용계획서"
                    : "안전관리비 사용내역서"
                }
                icon="security"
                cardTitle={
                  props.selectedItemId === "start-2-2"
                    ? "안전관리비 사용계획서"
                    : "안전관리비 사용내역서"
                }
                cardDescription={
                  props.selectedItemId === "start-2-1"
                    ? "안전관리비 관련 항목별 사용계획을 입력하고 관리하세요."
                    : "안전관리비 관련 항목별 사용내역을 입력하고 관리하세요."
                }
                saveButtonText="저장"
                getDefaultPresetsFromStorage={
                  props.getDefaultPresetsFromStorage
                }
                saveDefaultPresetsToStorage={props.saveDefaultPresetsToStorage}
                onClearAllPresets={props.onClearAllPresets}
              />
            )}

            {/* 환경보전비 사용내역서 폼 */}
            {isEnviManagePlan && (
              <UsagePlanForm
                selectedItemId={props.selectedItemId}
                selectedPresets={props.selectedPresets}
                presets={props.presets}
                usagePlan={props.enviManagePlan}
                onUsagePlanChange={props.onEnviManagePlanChange}
                onSelectPreset={props.onSelectPreset}
                onOpenPresetModal={props.onOpenPresetModal}
                onDocumentGenerate={props.onDocumentGenerate}
                title={
                  props.selectedItemId === "start-2-3"
                    ? "환경보전비 사용계획서"
                    : "환경보전비 사용내역서"
                }
                description={
                  props.selectedItemId === "start-2-3"
                    ? "환경보전비 사용계획서"
                    : "환경보전비 사용내역서"
                }
                icon="eco"
                cardTitle={
                  props.selectedItemId === "start-2-3"
                    ? "환경보전비 사용계획서"
                    : "환경보전비 사용내역서"
                }
                cardDescription={
                  props.selectedItemId === "start-2-3"
                    ? "환경보전 관련 항목별 사용계획을 입력하고 관리하세요."
                    : "환경보전 관련 항목별 사용내역을 입력하고 관리하세요."
                }
                saveButtonText="저장"
                getDefaultPresetsFromStorage={
                  props.getDefaultPresetsFromStorage
                }
                saveDefaultPresetsToStorage={props.saveDefaultPresetsToStorage}
                onClearAllPresets={props.onClearAllPresets}
              />
            )}

            {/* 기본 정보 설정 확인 - 기본정보 기반 항목 선택 시 */}
            {props.fileInfos.length === 0 &&
              props.selectedItemId &&
              !isSafetyManagePlan &&
              !isEnviManagePlan &&
              !isPhasedStatement &&
              !props.requiresFile(props.selectedItemId) &&
              isPresetRequired(props.selectedItemId) && (
                <div
                  className="card shadow-sm"
                  style={{ border: "none", borderRadius: "16px" }}
                >
                  <div
                    className="card-header bg-white border-0 pt-4"
                    style={{ borderRadius: "16px 16px 0 0" }}
                  >
                    <h5 className="card-title mb-0 d-flex align-items-center">
                      <span className="material-symbols-outlined me-2 text-primary">
                        settings
                      </span>
                      기본 정보 설정 확인
                    </h5>
                  </div>
                  <div className="card-body">
                    {/* 프리셋 설정 영역 - 항상 표시 */}
                    <div className="mb-4 p-3 bg-light rounded-3">
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label className="form-label small text-muted mb-1">
                            회사정보
                          </label>
                          <div className="d-flex gap-2">
                            <select
                              className="form-select"
                              value={
                                props.selectedPresets.companyInfo?.id || ""
                              }
                              onChange={(e) => {
                                const preset = props.presets.find(
                                  (p) =>
                                    p.id === e.target.value &&
                                    p.type === "companyInfo"
                                );
                                props.onSelectPreset("companyInfo", preset);
                                // 선택된 프리셋을 기본 정보로 설정
                                if (preset) {
                                  const currentDefaults =
                                    props.getDefaultPresetsFromStorage();
                                  const updatedDefaults = {
                                    ...currentDefaults,
                                    companyInfo: preset,
                                  };
                                  props.saveDefaultPresetsToStorage(
                                    updatedDefaults
                                  );
                                }
                              }}
                            >
                              <option value="">회사정보 선택</option>
                              {props.presets
                                .filter((p) => p.type === "companyInfo")
                                .map((preset) => {
                                  const storedDefaults =
                                    props.getDefaultPresetsFromStorage();
                                  const isDefault =
                                    storedDefaults?.companyInfo?.id ===
                                    preset.id;
                                  return (
                                    <option key={preset.id} value={preset.id}>
                                      {preset.name}
                                      {isDefault ? " (기본)" : ""}
                                    </option>
                                  );
                                })}
                            </select>
                            {props.selectedPresets.companyInfo && (
                              <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm px-2"
                                onClick={() => {
                                  props.onClearAllPresets();
                                }}
                                title="선택 취소"
                              >
                                <span
                                  className="material-symbols-outlined"
                                  style={{ fontSize: "16px" }}
                                >
                                  close
                                </span>
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <label className="form-label small text-muted mb-1">
                            현장대리인
                          </label>
                          <div className="d-flex gap-2">
                            <select
                              className="form-select"
                              value={
                                props.selectedPresets.fieldRepresentative?.id ||
                                ""
                              }
                              onChange={(e) => {
                                const preset = props.presets.find(
                                  (p) =>
                                    p.id === e.target.value &&
                                    p.type === "fieldRepresentative"
                                );
                                props.onSelectPreset(
                                  "fieldRepresentative",
                                  preset
                                );
                                // 선택된 프리셋을 기본 정보로 설정
                                if (preset) {
                                  const currentDefaults =
                                    props.getDefaultPresetsFromStorage();
                                  const updatedDefaults = {
                                    ...currentDefaults,
                                    fieldRepresentative: preset,
                                  };
                                  props.saveDefaultPresetsToStorage(
                                    updatedDefaults
                                  );
                                }
                              }}
                              disabled={!props.selectedPresets.companyInfo}
                            >
                              <option value="">
                                {!props.selectedPresets.companyInfo
                                  ? "회사정보를 먼저 선택하세요"
                                  : "현장대리인 선택"}
                              </option>
                              {props.selectedPresets.companyInfo &&
                                props.presets
                                  .filter(
                                    (p) =>
                                      p.type === "fieldRepresentative" &&
                                      String((p.data as any).companyId) ===
                                        props.selectedPresets.companyInfo?.id.split(
                                          "-"
                                        )[0]
                                  )
                                  .map((preset) => {
                                    const storedDefaults =
                                      props.getDefaultPresetsFromStorage();
                                    const isDefault =
                                      storedDefaults?.fieldRepresentative
                                        ?.id === preset.id;
                                    return (
                                      <option key={preset.id} value={preset.id}>
                                        {preset.name}
                                        {isDefault ? " (기본)" : ""}
                                      </option>
                                    );
                                  })}
                            </select>
                            {props.selectedPresets.fieldRepresentative &&
                              props.selectedPresets.companyInfo && (
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary btn-sm px-2"
                                  onClick={() => {
                                    props.onSelectPreset(
                                      "fieldRepresentative",
                                      undefined
                                    );
                                    props.onClearDefaultPreset(
                                      "fieldRepresentative"
                                    );
                                  }}
                                  title="선택 취소"
                                >
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ fontSize: "16px" }}
                                  >
                                    close
                                  </span>
                                </button>
                              )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <label className="form-label small text-muted mb-1">
                            공사정보
                          </label>
                          <div className="d-flex gap-2">
                            <select
                              className="form-select"
                              value={
                                props.selectedPresets.projectInfo?.id || ""
                              }
                              onChange={(e) => {
                                const preset = props.presets.find(
                                  (p) =>
                                    p.id === e.target.value &&
                                    p.type === "projectInfo"
                                );
                                props.onSelectPreset("projectInfo", preset);
                                // 선택된 프리셋을 기본 정보로 설정
                                if (preset) {
                                  const currentDefaults =
                                    props.getDefaultPresetsFromStorage();
                                  const updatedDefaults = {
                                    ...currentDefaults,
                                    projectInfo: preset,
                                  };
                                  props.saveDefaultPresetsToStorage(
                                    updatedDefaults
                                  );
                                }
                              }}
                              disabled={!props.selectedPresets.companyInfo}
                            >
                              <option value="">
                                {!props.selectedPresets.companyInfo
                                  ? "회사정보를 먼저 선택하세요"
                                  : "공사정보 선택"}
                              </option>
                              {props.selectedPresets.companyInfo &&
                                props.presets
                                  .filter(
                                    (p) =>
                                      p.type === "projectInfo" &&
                                      String((p.data as any).companyId) ===
                                        props.selectedPresets.companyInfo?.id.split(
                                          "-"
                                        )[0]
                                  )
                                  .map((preset) => {
                                    const storedDefaults =
                                      props.getDefaultPresetsFromStorage();
                                    const isDefault =
                                      storedDefaults?.projectInfo?.id ===
                                      preset.id;
                                    return (
                                      <option key={preset.id} value={preset.id}>
                                        {preset.name}
                                        {isDefault ? " (기본)" : ""}
                                      </option>
                                    );
                                  })}
                            </select>
                            {props.selectedPresets.projectInfo &&
                              props.selectedPresets.companyInfo && (
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary btn-sm px-2"
                                  onClick={() => {
                                    props.onSelectPreset(
                                      "projectInfo",
                                      undefined
                                    );
                                    props.onClearDefaultPreset("projectInfo");
                                  }}
                                  title="선택 취소"
                                >
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ fontSize: "16px" }}
                                  >
                                    close
                                  </span>
                                </button>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 예정공정표 폼 - 착공계약서류 선택 시에만 표시 */}
                    {props.selectedItemId === "start-2-1" && (
                      <div className="mb-4">
                        <ScheduleForm
                          selectedItemId={props.selectedItemId}
                          scheduleData={props.scheduleData}
                          onScheduleDataChange={props.onScheduleDataChange}
                          selectedPresets={{
                            projectInfo: props.selectedPresets
                              .projectInfo as any,
                          }}
                        />
                      </div>
                    )}

                    {/* 상태에 따른 메시지 및 버튼 */}
                    {hasRequiredPresets() ? (
                      // 모든 정보가 설정된 경우
                      <div className="text-center py-4">
                        <div
                          className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                          style={{ width: "80px", height: "80px" }}
                        >
                          <span
                            className="material-symbols-outlined text-success"
                            style={{ fontSize: "2.5rem" }}
                          >
                            check_circle
                          </span>
                        </div>
                        <h4 className="fw-bold text-dark mb-2">
                          기본 정보 설정 완료
                        </h4>
                        <p className="text-muted mb-4">
                          모든 필요한 정보가 설정되었습니다. 서류를 다운로드할
                          수 있습니다.
                        </p>

                        {/* 준공정산금액 입력 - 준공계서류만 */}
                        {isCompletionSettlementItem(props.selectedItemId) && (
                          <div className="mb-4">
                            <div className="row justify-content-center">
                              <div className="col-md-8">
                                <label className="form-label fw-semibold text-dark mb-2 d-flex align-items-center justify-content-center">
                                  <span
                                    className="material-symbols-outlined me-2 text-warning"
                                    style={{ fontSize: "18px" }}
                                  >
                                    calculate
                                  </span>
                                  준공정산금액
                                </label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={props.completionSettlementAmount}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(
                                        /[^0-9]/g,
                                        ""
                                      ); // 숫자만 추출
                                      const formattedValue = value
                                        ? Number(value).toLocaleString("ko-KR")
                                        : "";
                                      props.handleCompletionSettlementAmountChange(
                                        formattedValue
                                      );
                                    }}
                                    placeholder="준공정산금액을 입력하세요"
                                    style={{ borderRadius: "8px 0 0 8px" }}
                                  />
                                  <span
                                    className="input-group-text"
                                    style={{ borderRadius: "0 8px 8px 0" }}
                                  >
                                    원
                                  </span>
                                </div>
                                <small className="text-muted d-block mt-1 text-center">
                                  <span
                                    className="material-symbols-outlined me-1"
                                    style={{ fontSize: "12px" }}
                                  >
                                    info
                                  </span>
                                  서류에 반영할 준공정산금액을 입력하세요
                                </small>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* 청구 관련 입력 필드 - 청구서류만 */}
                        {isBillingItem(props.selectedItemId) && (
                          <div className="mb-4">
                            <div className="row justify-content-center">
                              <div className="col-md-10">
                                {/* 청구 일자 */}
                                <div className="mb-3">
                                  <label className="form-label fw-semibold text-dark mb-2 d-flex align-items-center justify-content-center">
                                    <span
                                      className="material-symbols-outlined me-2 text-info"
                                      style={{ fontSize: "18px" }}
                                    >
                                      calendar_today
                                    </span>
                                    청구 일자
                                  </label>
                                  <div className="input-group">
                                    <input
                                      type="date"
                                      className="form-control"
                                      value={props.claimDate}
                                      onChange={(e) => {
                                        props.handleClaimDateChange(
                                          e.target.value
                                        );
                                      }}
                                      style={{ borderRadius: "8px" }}
                                    />
                                  </div>
                                  <small className="text-muted d-block mt-1 text-center">
                                    <span
                                      className="material-symbols-outlined me-1"
                                      style={{ fontSize: "12px" }}
                                    >
                                      info
                                    </span>
                                    청구서류에 반영할 청구 일자를 선택하세요
                                  </small>
                                </div>

                                {/* 청구 금액 */}
                                <div className="mb-3">
                                  <label className="form-label fw-semibold text-dark mb-2 d-flex align-items-center justify-content-center">
                                    <span
                                      className="material-symbols-outlined me-2 text-success"
                                      style={{ fontSize: "18px" }}
                                    >
                                      payments
                                    </span>
                                    청구 금액
                                  </label>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={props.claimAmount}
                                      onChange={(e) => {
                                        const value = e.target.value.replace(
                                          /[^0-9]/g,
                                          ""
                                        ); // 숫자만 추출
                                        const formattedValue = value
                                          ? Number(value).toLocaleString(
                                              "ko-KR"
                                            )
                                          : "";
                                        props.handleClaimAmountChange(
                                          formattedValue
                                        );
                                      }}
                                      placeholder="청구 금액을 입력하세요"
                                      style={{
                                        borderRadius: "8px 0 0 8px",
                                      }}
                                    />
                                    <span
                                      className="input-group-text"
                                      style={{
                                        borderRadius: "0 8px 8px 0",
                                      }}
                                    >
                                      원
                                    </span>
                                  </div>
                                  <small className="text-muted d-block mt-1 text-center">
                                    <span
                                      className="material-symbols-outlined me-1"
                                      style={{ fontSize: "12px" }}
                                    >
                                      info
                                    </span>
                                    청구서류에 반영할 청구 금액을 입력하세요
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* 선급금 신청서 관련 입력 필드 - 선급금 신청서만 */}
                        {isPrepaymentItem(props.selectedItemId) && (
                          <div className="mb-4">
                            <div className="row justify-content-center">
                              <div className="col-md-10">
                                {/* 계약 관련 그룹 */}
                                <div
                                  className="card border-0 mb-4"
                                  style={{
                                    backgroundColor: "#e3f2fd",
                                    borderRadius: "12px",
                                  }}
                                >
                                  <div className="card-header bg-transparent border-0 py-3">
                                    <h6 className="fw-bold mb-0 text-primary text-center">
                                      계약 관련 정보
                                    </h6>
                                    <small className="text-muted text-center d-block mt-1">
                                      계약서에 명시된 비용 정보를 입력하세요
                                    </small>
                                  </div>
                                  <div className="card-body py-3">
                                    <div className="row g-3">
                                      {/* 계약 재료비 */}
                                      <div className="col-md-6">
                                        <label className="form-label fw-semibold text-dark mb-2">
                                          계약 재료비
                                        </label>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={props.contractMaterialCost}
                                            onChange={(e) => {
                                              const value =
                                                e.target.value.replace(
                                                  /[^0-9]/g,
                                                  ""
                                                );
                                              const formattedValue = value
                                                ? Number(value).toLocaleString(
                                                    "ko-KR"
                                                  )
                                                : "";
                                              props.handleContractMaterialCostChange(
                                                formattedValue
                                              );
                                            }}
                                            placeholder="계약 재료비를 입력하세요"
                                            style={{
                                              borderRadius: "8px 0 0 8px",
                                            }}
                                          />
                                          <span
                                            className="input-group-text"
                                            style={{
                                              borderRadius: "0 8px 8px 0",
                                            }}
                                          >
                                            원
                                          </span>
                                        </div>
                                      </div>

                                      {/* 계약 간접노무비 */}
                                      <div className="col-md-6">
                                        <label className="form-label fw-semibold text-dark mb-2">
                                          계약 간접노무비
                                        </label>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              props.contractIndirectLaborCost
                                            }
                                            onChange={(e) => {
                                              const value =
                                                e.target.value.replace(
                                                  /[^0-9]/g,
                                                  ""
                                                );
                                              const formattedValue = value
                                                ? Number(value).toLocaleString(
                                                    "ko-KR"
                                                  )
                                                : "";
                                              props.handleContractIndirectLaborCostChange(
                                                formattedValue
                                              );
                                            }}
                                            placeholder="계약 간접노무비를 입력하세요"
                                            style={{
                                              borderRadius: "8px 0 0 8px",
                                            }}
                                          />
                                          <span
                                            className="input-group-text"
                                            style={{
                                              borderRadius: "0 8px 8px 0",
                                            }}
                                          >
                                            원
                                          </span>
                                        </div>
                                      </div>

                                      {/* 계약경비 */}
                                      <div className="col-md-6">
                                        <label className="form-label fw-semibold text-dark mb-2">
                                          계약경비
                                        </label>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={props.contractExpenses}
                                            onChange={(e) => {
                                              const value =
                                                e.target.value.replace(
                                                  /[^0-9]/g,
                                                  ""
                                                );
                                              const formattedValue = value
                                                ? Number(value).toLocaleString(
                                                    "ko-KR"
                                                  )
                                                : "";
                                              props.handleContractExpensesChange(
                                                formattedValue
                                              );
                                            }}
                                            placeholder="계약경비를 입력하세요"
                                            style={{
                                              borderRadius: "8px 0 0 8px",
                                            }}
                                          />
                                          <span
                                            className="input-group-text"
                                            style={{
                                              borderRadius: "0 8px 8px 0",
                                            }}
                                          >
                                            원
                                          </span>
                                        </div>
                                      </div>

                                      {/* 계약 기타 */}
                                      <div className="col-md-6">
                                        <label className="form-label fw-semibold text-dark mb-2">
                                          계약 기타
                                        </label>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={props.contractOther}
                                            onChange={(e) => {
                                              const value =
                                                e.target.value.replace(
                                                  /[^0-9]/g,
                                                  ""
                                                );
                                              const formattedValue = value
                                                ? Number(value).toLocaleString(
                                                    "ko-KR"
                                                  )
                                                : "";
                                              props.handleContractOtherChange(
                                                formattedValue
                                              );
                                            }}
                                            placeholder="계약 기타 비용을 입력하세요"
                                            style={{
                                              borderRadius: "8px 0 0 8px",
                                            }}
                                          />
                                          <span
                                            className="input-group-text"
                                            style={{
                                              borderRadius: "0 8px 8px 0",
                                            }}
                                          >
                                            원
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* 선급금 관련 그룹 */}
                                <div
                                  className="card border-0"
                                  style={{
                                    backgroundColor: "#f3e5f5",
                                    borderRadius: "12px",
                                  }}
                                >
                                  <div className="card-header bg-transparent border-0 py-3">
                                    <h6
                                      className="fw-bold mb-0 text-center"
                                      style={{ color: "#6a1b9a" }}
                                    >
                                      선급금 조정 정보
                                    </h6>
                                    <small className="text-muted text-center d-block mt-1">
                                      선급금 조정 관련 비용 정보를 입력하세요
                                    </small>
                                  </div>
                                  <div className="card-body py-3">
                                    <div className="row g-3">
                                      {/* 선급금 조정 재료비 */}
                                      <div className="col-md-6">
                                        <label className="form-label fw-semibold text-dark mb-2">
                                          선급금 조정 재료비
                                        </label>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              props.prepaymentAdjustmentMaterialCost
                                            }
                                            onChange={(e) => {
                                              const value =
                                                e.target.value.replace(
                                                  /[^0-9]/g,
                                                  ""
                                                );
                                              const formattedValue = value
                                                ? Number(value).toLocaleString(
                                                    "ko-KR"
                                                  )
                                                : "";
                                              props.handlePrepaymentAdjustmentMaterialCostChange(
                                                formattedValue
                                              );
                                            }}
                                            placeholder="선급금 조정 재료비를 입력하세요"
                                            style={{
                                              borderRadius: "8px 0 0 8px",
                                            }}
                                          />
                                          <span
                                            className="input-group-text"
                                            style={{
                                              borderRadius: "0 8px 8px 0",
                                            }}
                                          >
                                            원
                                          </span>
                                        </div>
                                      </div>

                                      {/* 선급금 조정 간접노무비 */}
                                      <div className="col-md-6">
                                        <label className="form-label fw-semibold text-dark mb-2">
                                          선급금 조정 간접노무비
                                        </label>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={
                                              props.prepaymentAdjustmentIndirectLaborCost
                                            }
                                            onChange={(e) => {
                                              const value =
                                                e.target.value.replace(
                                                  /[^0-9]/g,
                                                  ""
                                                );
                                              const formattedValue = value
                                                ? Number(value).toLocaleString(
                                                    "ko-KR"
                                                  )
                                                : "";
                                              props.handlePrepaymentAdjustmentIndirectLaborCostChange(
                                                formattedValue
                                              );
                                            }}
                                            placeholder="선급금 조정 간접노무비를 입력하세요"
                                            style={{
                                              borderRadius: "8px 0 0 8px",
                                            }}
                                          />
                                          <span
                                            className="input-group-text"
                                            style={{
                                              borderRadius: "0 8px 8px 0",
                                            }}
                                          >
                                            원
                                          </span>
                                        </div>
                                      </div>

                                      {/* 선급금 경비 */}
                                      <div className="col-md-6">
                                        <label className="form-label fw-semibold text-dark mb-2">
                                          선급금 경비
                                        </label>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={props.prepaymentExpenses}
                                            onChange={(e) => {
                                              const value =
                                                e.target.value.replace(
                                                  /[^0-9]/g,
                                                  ""
                                                );
                                              const formattedValue = value
                                                ? Number(value).toLocaleString(
                                                    "ko-KR"
                                                  )
                                                : "";
                                              props.handlePrepaymentExpensesChange(
                                                formattedValue
                                              );
                                            }}
                                            placeholder="선급금 경비를 입력하세요"
                                            style={{
                                              borderRadius: "8px 0 0 8px",
                                            }}
                                          />
                                          <span
                                            className="input-group-text"
                                            style={{
                                              borderRadius: "0 8px 8px 0",
                                            }}
                                          >
                                            원
                                          </span>
                                        </div>
                                      </div>

                                      {/* 기타 */}
                                      <div className="col-md-6">
                                        <label className="form-label fw-semibold text-dark mb-2">
                                          기타
                                        </label>
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={props.prepaymentOther}
                                            onChange={(e) => {
                                              const value =
                                                e.target.value.replace(
                                                  /[^0-9]/g,
                                                  ""
                                                );
                                              const formattedValue = value
                                                ? Number(value).toLocaleString(
                                                    "ko-KR"
                                                  )
                                                : "";
                                              props.handlePrepaymentOtherChange(
                                                formattedValue
                                              );
                                            }}
                                            placeholder="기타 비용을 입력하세요"
                                            style={{
                                              borderRadius: "8px 0 0 8px",
                                            }}
                                          />
                                          <span
                                            className="input-group-text"
                                            style={{
                                              borderRadius: "0 8px 8px 0",
                                            }}
                                          >
                                            원
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        <button
                          className="btn btn-success btn-lg px-4 py-3"
                          disabled={
                            !isScheduleFormComplete() ||
                            (isCompletionSettlementItem(props.selectedItemId) &&
                              !props.completionSettlementAmount.trim()) ||
                            (isBillingItem(props.selectedItemId) &&
                              (!props.claimDate.trim() ||
                                !props.claimAmount.trim())) ||
                            (isPrepaymentItem(props.selectedItemId) &&
                              (!props.contractMaterialCost.trim() ||
                                !props.contractIndirectLaborCost.trim() ||
                                !props.contractExpenses.trim() ||
                                !props.contractOther.trim() ||
                                !props.prepaymentAdjustmentMaterialCost.trim() ||
                                !props.prepaymentAdjustmentIndirectLaborCost.trim() ||
                                !props.prepaymentExpenses.trim() ||
                                !props.prepaymentOther.trim()))
                          }
                          onClick={() => {
                            props.onDocumentGenerate(
                              props.selectedItemId,
                              props.selectedPresets,
                              props.selectedItemId === "start-2-1"
                                ? props.scheduleData
                                : undefined
                            );
                          }}
                          title={
                            !isScheduleFormComplete()
                              ? "예정공정표를 완전히 입력해주세요"
                              : isCompletionSettlementItem(
                                  props.selectedItemId
                                ) && !props.completionSettlementAmount.trim()
                              ? "준공정산금액을 입력해주세요"
                              : isBillingItem(props.selectedItemId) &&
                                (!props.claimDate.trim() ||
                                  !props.claimAmount.trim())
                              ? "청구 일자와 청구 금액을 모두 입력해주세요"
                              : isPrepaymentItem(props.selectedItemId) &&
                                (!props.contractMaterialCost.trim() ||
                                  !props.contractIndirectLaborCost.trim() ||
                                  !props.contractExpenses.trim() ||
                                  !props.contractOther.trim() ||
                                  !props.prepaymentAdjustmentMaterialCost.trim() ||
                                  !props.prepaymentAdjustmentIndirectLaborCost.trim() ||
                                  !props.prepaymentExpenses.trim() ||
                                  !props.prepaymentOther.trim())
                              ? "모든 선급금 관련 항목을 입력해주세요"
                              : ""
                          }
                        >
                          <span className="material-symbols-outlined me-2">
                            download
                          </span>
                          다운로드
                        </button>
                      </div>
                    ) : (
                      // 정보가 설정되지 않은 경우
                      <div className="text-center py-4">
                        <div
                          className="bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                          style={{ width: "80px", height: "80px" }}
                        >
                          <span
                            className="material-symbols-outlined text-warning"
                            style={{ fontSize: "2.5rem" }}
                          >
                            warning
                          </span>
                        </div>
                        <h4 className="fw-bold text-dark mb-2">
                          기본 정보를 설정해주세요
                        </h4>
                        <p className="text-muted mb-4">
                          서류 생성을 위해 회사정보, 현장대리인, 공사정보 기본
                          정보가 모두 필요합니다.
                          {!hasDefaultPresets() &&
                            " 아래 버튼을 클릭하여 기본 정보를 등록하세요."}
                        </p>
                        <div className="d-flex gap-2 justify-content-center">
                          <button
                            className="btn btn-secondary btn-lg px-4 py-3"
                            disabled={true}
                            title="기본 정보를 모두 설정해주세요"
                          >
                            <span className="material-symbols-outlined me-2">
                              block
                            </span>
                            다운로드 (설정 필요)
                          </button>
                          {!hasDefaultPresets() && (
                            <button
                              onClick={() =>
                                handleOpenPresetModalWithLoginCheck(
                                  "companyInfo"
                                )
                              }
                              className="btn btn-warning btn-lg px-4 py-3"
                            >
                              <span className="material-symbols-outlined me-2">
                                bookmark_manager
                              </span>
                              기본 정보 설정하기
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

            {/* 서류 생성 - 기본정보 불필요 항목 선택 시 */}
            {props.fileInfos.length === 0 &&
              props.selectedItemId &&
              !isSafetyManagePlan &&
              !isEnviManagePlan &&
              !isPhasedStatement &&
              !props.requiresFile(props.selectedItemId) &&
              !isPresetRequired(props.selectedItemId) && (
                <div
                  className="card shadow-sm"
                  style={{ border: "none", borderRadius: "16px" }}
                >
                  <div
                    className="card-header bg-white border-0 pt-4"
                    style={{ borderRadius: "16px 16px 0 0" }}
                  >
                    <h5 className="card-title mb-0 d-flex align-items-center">
                      <span className="material-symbols-outlined me-2 text-success">
                        description
                      </span>
                      서류 생성
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="text-center py-5">
                      <div
                        className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{ width: "80px", height: "80px" }}
                      >
                        <span
                          className="material-symbols-outlined text-success"
                          style={{ fontSize: "2.5rem" }}
                        >
                          download_done
                        </span>
                      </div>
                      <h4 className="fw-bold text-dark mb-2">
                        {props.selectedItemInfo?.title}
                      </h4>
                      <p className="text-muted mb-4">
                        이 서류는 별도의 기본 정보 설정 없이 바로 다운로드할 수
                        있습니다.
                      </p>

                      {/* 준공정산금액 입력 - 준공계서류만 */}
                      {isCompletionSettlementItem(props.selectedItemId) && (
                        <div className="mb-4">
                          <div className="row justify-content-center">
                            <div className="col-md-8">
                              <label className="form-label fw-semibold text-dark mb-2 d-flex align-items-center justify-content-center">
                                <span
                                  className="material-symbols-outlined me-2 text-warning"
                                  style={{ fontSize: "18px" }}
                                >
                                  calculate
                                </span>
                                준공정산금액
                              </label>
                              <div className="input-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={props.completionSettlementAmount}
                                  onChange={(e) => {
                                    const value = e.target.value.replace(
                                      /[^0-9]/g,
                                      ""
                                    ); // 숫자만 추출
                                    const formattedValue = value
                                      ? Number(value).toLocaleString("ko-KR")
                                      : "";
                                    props.handleCompletionSettlementAmountChange(
                                      formattedValue
                                    );
                                  }}
                                  placeholder="준공정산금액을 입력하세요"
                                  style={{ borderRadius: "8px 0 0 8px" }}
                                />
                                <span
                                  className="input-group-text"
                                  style={{ borderRadius: "0 8px 8px 0" }}
                                >
                                  원
                                </span>
                              </div>
                              <small className="text-muted d-block mt-1 text-center">
                                <span
                                  className="material-symbols-outlined me-1"
                                  style={{ fontSize: "12px" }}
                                >
                                  info
                                </span>
                                서류에 반영할 준공정산금액을 입력하세요
                              </small>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* 청구 관련 입력 필드 - 청구서류만 */}
                      {isBillingItem(props.selectedItemId) && (
                        <div className="mb-4">
                          <div className="row justify-content-center">
                            <div className="col-md-10">
                              {/* 청구 일자 */}
                              <div className="mb-3">
                                <label className="form-label fw-semibold text-dark mb-2 d-flex align-items-center justify-content-center">
                                  <span
                                    className="material-symbols-outlined me-2 text-info"
                                    style={{ fontSize: "18px" }}
                                  >
                                    calendar_today
                                  </span>
                                  청구 일자
                                </label>
                                <div className="input-group">
                                  <input
                                    type="date"
                                    className="form-control"
                                    value={props.claimDate}
                                    onChange={(e) => {
                                      props.handleClaimDateChange(
                                        e.target.value
                                      );
                                    }}
                                    style={{ borderRadius: "8px" }}
                                  />
                                </div>
                                <small className="text-muted d-block mt-1 text-center">
                                  <span
                                    className="material-symbols-outlined me-1"
                                    style={{ fontSize: "12px" }}
                                  >
                                    info
                                  </span>
                                  청구서류에 반영할 청구 일자를 선택하세요
                                </small>
                              </div>

                              {/* 청구 금액 */}
                              <div className="mb-3">
                                <label className="form-label fw-semibold text-dark mb-2 d-flex align-items-center justify-content-center">
                                  <span
                                    className="material-symbols-outlined me-2 text-success"
                                    style={{ fontSize: "18px" }}
                                  >
                                    payments
                                  </span>
                                  청구 금액
                                </label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={props.claimAmount}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(
                                        /[^0-9]/g,
                                        ""
                                      ); // 숫자만 추출
                                      const formattedValue = value
                                        ? Number(value).toLocaleString("ko-KR")
                                        : "";
                                      props.handleClaimAmountChange(
                                        formattedValue
                                      );
                                    }}
                                    placeholder="청구 금액을 입력하세요"
                                    style={{
                                      borderRadius: "8px 0 0 8px",
                                    }}
                                  />
                                  <span
                                    className="input-group-text"
                                    style={{
                                      borderRadius: "0 8px 8px 0",
                                    }}
                                  >
                                    원
                                  </span>
                                </div>
                                <small className="text-muted d-block mt-1 text-center">
                                  <span
                                    className="material-symbols-outlined me-1"
                                    style={{ fontSize: "12px" }}
                                  >
                                    info
                                  </span>
                                  청구서류에 반영할 청구 금액을 입력하세요
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* 선급금 신청서 관련 입력 필드 - 선급금 신청서만 */}
                      {isPrepaymentItem(props.selectedItemId) && (
                        <div className="mb-4">
                          <div className="row justify-content-center">
                            <div className="col-md-10">
                              {/* 계약 관련 그룹 */}
                              <div
                                className="card border-0 mb-4"
                                style={{
                                  backgroundColor: "#e3f2fd",
                                  borderRadius: "12px",
                                }}
                              >
                                <div className="card-header bg-transparent border-0 py-3">
                                  <h6 className="fw-bold mb-0 text-primary text-center">
                                    계약 관련 정보
                                  </h6>
                                  <small className="text-muted text-center d-block mt-1">
                                    계약서에 명시된 비용 정보를 입력하세요
                                  </small>
                                </div>
                                <div className="card-body py-3">
                                  <div className="row g-3">
                                    {/* 계약 재료비 */}
                                    <div className="col-md-6">
                                      <label className="form-label fw-semibold text-dark mb-2">
                                        계약 재료비
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={props.contractMaterialCost}
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                            const formattedValue = value
                                              ? Number(value).toLocaleString(
                                                  "ko-KR"
                                                )
                                              : "";
                                            props.handleContractMaterialCostChange(
                                              formattedValue
                                            );
                                          }}
                                          placeholder="계약 재료비를 입력하세요"
                                          style={{
                                            borderRadius: "8px 0 0 8px",
                                          }}
                                        />
                                        <span
                                          className="input-group-text"
                                          style={{
                                            borderRadius: "0 8px 8px 0",
                                          }}
                                        >
                                          원
                                        </span>
                                      </div>
                                    </div>

                                    {/* 계약 간접노무비 */}
                                    <div className="col-md-6">
                                      <label className="form-label fw-semibold text-dark mb-2">
                                        계약 간접노무비
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            props.contractIndirectLaborCost
                                          }
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                            const formattedValue = value
                                              ? Number(value).toLocaleString(
                                                  "ko-KR"
                                                )
                                              : "";
                                            props.handleContractIndirectLaborCostChange(
                                              formattedValue
                                            );
                                          }}
                                          placeholder="계약 간접노무비를 입력하세요"
                                          style={{
                                            borderRadius: "8px 0 0 8px",
                                          }}
                                        />
                                        <span
                                          className="input-group-text"
                                          style={{
                                            borderRadius: "0 8px 8px 0",
                                          }}
                                        >
                                          원
                                        </span>
                                      </div>
                                    </div>

                                    {/* 계약경비 */}
                                    <div className="col-md-6">
                                      <label className="form-label fw-semibold text-dark mb-2">
                                        계약경비
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={props.contractExpenses}
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                            const formattedValue = value
                                              ? Number(value).toLocaleString(
                                                  "ko-KR"
                                                )
                                              : "";
                                            props.handleContractExpensesChange(
                                              formattedValue
                                            );
                                          }}
                                          placeholder="계약경비를 입력하세요"
                                          style={{
                                            borderRadius: "8px 0 0 8px",
                                          }}
                                        />
                                        <span
                                          className="input-group-text"
                                          style={{
                                            borderRadius: "0 8px 8px 0",
                                          }}
                                        >
                                          원
                                        </span>
                                      </div>
                                    </div>

                                    {/* 계약 기타 */}
                                    <div className="col-md-6">
                                      <label className="form-label fw-semibold text-dark mb-2">
                                        계약 기타
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={props.contractOther}
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                            const formattedValue = value
                                              ? Number(value).toLocaleString(
                                                  "ko-KR"
                                                )
                                              : "";
                                            props.handleContractOtherChange(
                                              formattedValue
                                            );
                                          }}
                                          placeholder="계약 기타 비용을 입력하세요"
                                          style={{
                                            borderRadius: "8px 0 0 8px",
                                          }}
                                        />
                                        <span
                                          className="input-group-text"
                                          style={{
                                            borderRadius: "0 8px 8px 0",
                                          }}
                                        >
                                          원
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* 선급금 관련 그룹 */}
                              <div
                                className="card border-0"
                                style={{
                                  backgroundColor: "#f3e5f5",
                                  borderRadius: "12px",
                                }}
                              >
                                <div className="card-header bg-transparent border-0 py-3">
                                  <h6
                                    className="fw-bold mb-0 text-center"
                                    style={{ color: "#6a1b9a" }}
                                  >
                                    선급금 조정 정보
                                  </h6>
                                  <small className="text-muted text-center d-block mt-1">
                                    선급금 조정 관련 비용 정보를 입력하세요
                                  </small>
                                </div>
                                <div className="card-body py-3">
                                  <div className="row g-3">
                                    {/* 선급금 조정 재료비 */}
                                    <div className="col-md-6">
                                      <label className="form-label fw-semibold text-dark mb-2">
                                        선급금 조정 재료비
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            props.prepaymentAdjustmentMaterialCost
                                          }
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                            const formattedValue = value
                                              ? Number(value).toLocaleString(
                                                  "ko-KR"
                                                )
                                              : "";
                                            props.handlePrepaymentAdjustmentMaterialCostChange(
                                              formattedValue
                                            );
                                          }}
                                          placeholder="선급금 조정 재료비를 입력하세요"
                                          style={{
                                            borderRadius: "8px 0 0 8px",
                                          }}
                                        />
                                        <span
                                          className="input-group-text"
                                          style={{
                                            borderRadius: "0 8px 8px 0",
                                          }}
                                        >
                                          원
                                        </span>
                                      </div>
                                    </div>

                                    {/* 선급금 조정 간접노무비 */}
                                    <div className="col-md-6">
                                      <label className="form-label fw-semibold text-dark mb-2">
                                        선급금 조정 간접노무비
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={
                                            props.prepaymentAdjustmentIndirectLaborCost
                                          }
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                            const formattedValue = value
                                              ? Number(value).toLocaleString(
                                                  "ko-KR"
                                                )
                                              : "";
                                            props.handlePrepaymentAdjustmentIndirectLaborCostChange(
                                              formattedValue
                                            );
                                          }}
                                          placeholder="선급금 조정 간접노무비를 입력하세요"
                                          style={{
                                            borderRadius: "8px 0 0 8px",
                                          }}
                                        />
                                        <span
                                          className="input-group-text"
                                          style={{
                                            borderRadius: "0 8px 8px 0",
                                          }}
                                        >
                                          원
                                        </span>
                                      </div>
                                    </div>

                                    {/* 선급금 경비 */}
                                    <div className="col-md-6">
                                      <label className="form-label fw-semibold text-dark mb-2">
                                        선급금 경비
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={props.prepaymentExpenses}
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                            const formattedValue = value
                                              ? Number(value).toLocaleString(
                                                  "ko-KR"
                                                )
                                              : "";
                                            props.handlePrepaymentExpensesChange(
                                              formattedValue
                                            );
                                          }}
                                          placeholder="선급금 경비를 입력하세요"
                                          style={{
                                            borderRadius: "8px 0 0 8px",
                                          }}
                                        />
                                        <span
                                          className="input-group-text"
                                          style={{
                                            borderRadius: "0 8px 8px 0",
                                          }}
                                        >
                                          원
                                        </span>
                                      </div>
                                    </div>

                                    {/* 기타 */}
                                    <div className="col-md-6">
                                      <label className="form-label fw-semibold text-dark mb-2">
                                        기타
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={props.prepaymentOther}
                                          onChange={(e) => {
                                            const value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                            const formattedValue = value
                                              ? Number(value).toLocaleString(
                                                  "ko-KR"
                                                )
                                              : "";
                                            props.handlePrepaymentOtherChange(
                                              formattedValue
                                            );
                                          }}
                                          placeholder="기타 비용을 입력하세요"
                                          style={{
                                            borderRadius: "8px 0 0 8px",
                                          }}
                                        />
                                        <span
                                          className="input-group-text"
                                          style={{
                                            borderRadius: "0 8px 8px 0",
                                          }}
                                        >
                                          원
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="d-flex gap-2 justify-content-center">
                        <div className="position-relative">
                          <button
                            className="btn btn-success btn-lg px-4 py-3"
                            disabled={
                              !hasRequiredPresets() ||
                              !isScheduleFormComplete() ||
                              (isCompletionSettlementItem(
                                props.selectedItemId
                              ) &&
                                !props.completionSettlementAmount.trim()) ||
                              (isBillingItem(props.selectedItemId) &&
                                (!props.claimDate.trim() ||
                                  !props.claimAmount.trim())) ||
                              (isPrepaymentItem(props.selectedItemId) &&
                                (!props.contractMaterialCost.trim() ||
                                  !props.contractIndirectLaborCost.trim() ||
                                  !props.contractExpenses.trim() ||
                                  !props.contractOther.trim() ||
                                  !props.prepaymentAdjustmentMaterialCost.trim() ||
                                  !props.prepaymentAdjustmentIndirectLaborCost.trim() ||
                                  !props.prepaymentExpenses.trim() ||
                                  !props.prepaymentOther.trim()))
                            }
                            onClick={() => {
                              if (hasRequiredPresets()) {
                                // 예정공정표가 필요한 항목들
                                const scheduleRequiredItems = ["start-2-1"];
                                props.onDocumentGenerate(
                                  props.selectedItemId,
                                  props.selectedPresets,
                                  scheduleRequiredItems.includes(
                                    props.selectedItemId
                                  )
                                    ? props.scheduleData
                                    : undefined
                                );
                              }
                            }}
                            data-bs-toggle={
                              !hasRequiredPresets() ||
                              !isScheduleFormComplete() ||
                              (isCompletionSettlementItem(
                                props.selectedItemId
                              ) &&
                                !props.completionSettlementAmount.trim())
                                ? "tooltip"
                                : undefined
                            }
                            data-bs-placement="top"
                            data-bs-title={
                              !hasRequiredPresets()
                                ? "기본 정보를 모두 설정해주세요"
                                : !isScheduleFormComplete()
                                ? "예정공정표를 완전히 입력해주세요"
                                : isCompletionSettlementItem(
                                    props.selectedItemId
                                  ) && !props.completionSettlementAmount.trim()
                                ? "준공정산금액을 입력해주세요"
                                : isBillingItem(props.selectedItemId) &&
                                  (!props.claimDate.trim() ||
                                    !props.claimAmount.trim())
                                ? "청구 일자와 청구 금액을 모두 입력해주세요"
                                : isPrepaymentItem(props.selectedItemId) &&
                                  (!props.contractMaterialCost.trim() ||
                                    !props.contractIndirectLaborCost.trim() ||
                                    !props.contractExpenses.trim() ||
                                    !props.contractOther.trim() ||
                                    !props.prepaymentAdjustmentMaterialCost.trim() ||
                                    !props.prepaymentAdjustmentIndirectLaborCost.trim() ||
                                    !props.prepaymentExpenses.trim() ||
                                    !props.prepaymentOther.trim())
                                ? "모든 선급금 관련 항목을 입력해주세요"
                                : undefined
                            }
                            title={
                              !hasRequiredPresets()
                                ? "기본 정보를 모두 설정해주세요"
                                : !isScheduleFormComplete()
                                ? "예정공정표를 완전히 입력해주세요"
                                : isCompletionSettlementItem(
                                    props.selectedItemId
                                  ) && !props.completionSettlementAmount.trim()
                                ? "준공정산금액을 입력해주세요"
                                : isBillingItem(props.selectedItemId) &&
                                  (!props.claimDate.trim() ||
                                    !props.claimAmount.trim())
                                ? "청구 일자와 청구 금액을 모두 입력해주세요"
                                : isPrepaymentItem(props.selectedItemId) &&
                                  (!props.contractMaterialCost.trim() ||
                                    !props.contractIndirectLaborCost.trim() ||
                                    !props.contractExpenses.trim() ||
                                    !props.contractOther.trim() ||
                                    !props.prepaymentAdjustmentMaterialCost.trim() ||
                                    !props.prepaymentAdjustmentIndirectLaborCost.trim() ||
                                    !props.prepaymentExpenses.trim() ||
                                    !props.prepaymentOther.trim())
                                ? "모든 선급금 관련 항목을 입력해주세요"
                                : ""
                            }
                          >
                            <span className="material-symbols-outlined me-2">
                              download
                            </span>
                            다운로드
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

            {/* 청구서류 전용 가이드 영역 - 다운로드 버튼 하단 */}
            {props.selectedItemId === "billing-1" && (
              <div className="mb-4 mt-4">
                <h5 className="fw-bold mb-4 text-center text-dark">
                  💰 청구서류 업무 가이드
                </h5>

                {/* 첫 번째 행 */}
                <div className="row g-4 mb-4">
                  {/* 국세 관련 서류 */}
                  <div className="col-md-6">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#e3f2fd",
                        borderRadius: "16px",
                        border: "1px solid #bbdefb",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6 className="fw-bold mb-3 text-primary">
                          국세 관련 서류
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              청구세금계산서 발급:
                            </small>
                            <p className="small text-muted mb-2">
                              조회/발급 → 전자세금계산서 → 발급
                            </p>
                            <p className="small text-muted mb-2">
                              품목: 건설공사비 등
                            </p>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              국세완납증명서 발급:
                            </small>
                            <p className="small text-muted mb-2">
                              조회/발급 → 증명서발급 → 완납증명서
                            </p>
                            <p className="small text-muted mb-0">
                              용도: 건설공사 대금청구용
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://www.hometax.go.kr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary btn-sm w-100"
                            style={{ borderRadius: "8px" }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            홈택스
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 지방세완납증명서 */}
                  <div className="col-md-6">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#fff3e0",
                        borderRadius: "16px",
                        border: "1px solid #ffcc80",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6 className="fw-bold mb-3 text-warning">
                          지방세완납증명서
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              접속방법:
                            </small>
                            <p className="small text-muted mb-2">
                              간편인증 또는 공인인증서 로그인
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              서비스 → 신청·조회·발급 → 지방세완납증명서
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              용도:
                            </small>
                            <p className="small text-muted mb-2">
                              공사대금 청구
                            </p>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              발급시간:
                            </small>
                            <p className="small text-muted mb-0">즉시 발급</p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://www.gov.kr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-warning btn-sm w-100"
                            style={{ borderRadius: "8px" }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            정부24
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 두 번째 행 */}
                <div className="row g-4">
                  {/* 사회보험 완납증명서 */}
                  <div className="col-md-6">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#e8f5e8",
                        borderRadius: "16px",
                        border: "1px solid #a5d6a7",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6 className="fw-bold mb-3 text-success">
                          사회보험 완납증명서
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              본사 고용산재완납증명서:
                            </small>
                            <p className="small text-muted mb-2">
                              증명서발급 → 완납증명서 (현장이 아닌 본사)
                            </p>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              건강연금완납증명서:
                            </small>
                            <p className="small text-muted mb-0">
                              사업장 공인인증서 로그인 → 증명서발급
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <div className="row g-2">
                            <div className="col-6">
                              <a
                                href="https://total.comwel.or.kr/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-success btn-sm w-100"
                                style={{
                                  borderRadius: "8px",
                                  fontSize: "12px",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined me-1"
                                  style={{ fontSize: "14px" }}
                                >
                                  open_in_new
                                </span>
                                고용산재
                              </a>
                            </div>
                            <div className="col-6">
                              <a
                                href="https://si4n.nhis.or.kr/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-success btn-sm w-100"
                                style={{
                                  borderRadius: "8px",
                                  fontSize: "12px",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined me-1"
                                  style={{ fontSize: "14px" }}
                                >
                                  open_in_new
                                </span>
                                건강연금
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 하자보증서 발급 */}
                  <div className="col-md-6">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#f3e5f5",
                        borderRadius: "16px",
                        border: "1px solid #e1bee7",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6
                          className="fw-bold mb-3"
                          style={{ color: "#7b1fa2" }}
                        >
                          하자보증서 발급
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              나라장터 - 하자보증신청:
                            </small>
                            <p className="small text-muted mb-2">
                              계약관리 → 보증 → 하자보증신청
                            </p>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              전문건설공제조합 - 보증서 발급:
                            </small>
                            <p className="small text-muted mb-0">
                              보증업무 → 보증서신청 → 하자보증
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <div className="row g-2">
                            <div className="col-6">
                              <a
                                href="https://www.g2b.go.kr/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm w-100"
                                style={{
                                  borderRadius: "8px",
                                  fontSize: "12px",
                                  backgroundColor: "#7b1fa2",
                                  color: "white",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined me-1"
                                  style={{ fontSize: "14px" }}
                                >
                                  open_in_new
                                </span>
                                나라장터
                              </a>
                            </div>
                            <div className="col-6">
                              <a
                                href="https://www.kfinco.co.kr/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-sm w-100"
                                style={{
                                  borderRadius: "8px",
                                  fontSize: "12px",
                                  borderColor: "#7b1fa2",
                                  color: "#7b1fa2",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined me-1"
                                  style={{ fontSize: "14px" }}
                                >
                                  open_in_new
                                </span>
                                공제조합
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* 착공계약서류 전용 가이드 영역 - 다운로드 버튼 하단 */}
            {props.selectedItemId === "start-2-1" && (
              <div className="mb-4 mt-4">
                <h5 className="fw-bold mb-4 text-center text-dark">
                  🚧 착공계약서류 업무 가이드
                </h5>

                {/* 첫 번째 행 */}
                <div className="row g-4 mb-4">
                  {/* 고용·산재보험 가입증명서 */}
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#e3f2fd",
                        borderRadius: "16px",
                        border: "1px solid #bbdefb",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6 className="fw-bold mb-3 text-primary">
                          고용·산재보험 가입증명서
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              증명서발급 → 가입증명서 → 고용산재가입증명서
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              처리절차:
                            </small>
                            <ol className="small text-muted mb-2 ps-3">
                              <li>사업개시신고 완료된 현장 선택</li>
                              <li>증명서 종류 선택 (가입증명서)</li>
                              <li>발급 및 출력</li>
                            </ol>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              소요시간:
                            </small>
                            <p className="small text-muted mb-2">즉시 발급</p>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              용도:
                            </small>
                            <p className="small text-muted mb-0">
                              착공신고, 발주처 제출용
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://total.comwel.or.kr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary btn-sm w-100"
                            style={{ borderRadius: "8px" }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            고용산재토탈서비스
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 사대보험가입증명서 */}
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#fff3e0",
                        borderRadius: "16px",
                        border: "1px solid #ffcc80",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6 className="fw-bold mb-3 text-warning">
                          사대보험가입증명서
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              접속방법:
                            </small>
                            <p className="small text-muted mb-2">
                              사업장 공인인증서 로그인
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              증명서발급 → 사업장가입자명부 → 4대보험가입증명서
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              처리절차:
                            </small>
                            <ol className="small text-muted mb-2 ps-3">
                              <li>발급대상 기간 설정</li>
                              <li>발급대상 직원 선택</li>
                              <li>증명서 종류 선택</li>
                              <li>발급 및 출력</li>
                            </ol>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              활용:
                            </small>
                            <p className="small text-muted mb-0">
                              노무비구분관리제 대응
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://www.4insure.or.kr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-warning btn-sm w-100"
                            style={{ borderRadius: "8px" }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            사대보험정보연계센터
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 키스콘 건설공사대장통보 */}
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#e8f5e8",
                        borderRadius: "16px",
                        border: "1px solid #a5d6a7",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6 className="fw-bold mb-3 text-success">
                          키스콘(KISCON) 건설공사대장통보
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              접속방법:
                            </small>
                            <p className="small text-muted mb-2">
                              건설업등록번호 + 공인인증서 로그인
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              건설공사대장통보 → 원도급 건설공사대장 작성
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              적용대상:
                            </small>
                            <p className="small text-muted mb-2">
                              1억원 이상 공사
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              통보기한:
                            </small>
                            <p className="small text-danger mb-2 fw-semibold">
                              계약체결 후 30일 이내
                            </p>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              🔗 CWS 건설공사정보시스템:
                            </small>
                            <p className="small text-muted mb-0">
                              공사정보관리 → 공사정보등록 (국토교통부 신고용)
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <div className="row g-2">
                            <div className="col-6">
                              <a
                                href="https://www.kiscon.net/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-success btn-sm w-100"
                                style={{
                                  borderRadius: "8px",
                                  fontSize: "12px",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined me-1"
                                  style={{ fontSize: "14px" }}
                                >
                                  open_in_new
                                </span>
                                키스콘
                              </a>
                            </div>
                            <div className="col-6">
                              <a
                                href="https://cws.kiscon.net/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-success btn-sm w-100"
                                style={{
                                  borderRadius: "8px",
                                  fontSize: "12px",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined me-1"
                                  style={{ fontSize: "14px" }}
                                >
                                  open_in_new
                                </span>
                                CWS
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 두 번째 행 */}
                <div className="row g-4">
                  {/* 건설근로자공제회 퇴직공제 */}
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#f3e5f5",
                        borderRadius: "16px",
                        border: "1px solid #e1bee7",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6
                          className="fw-bold mb-3"
                          style={{ color: "#7b1fa2" }}
                        >
                          건설근로자공제회 퇴직공제
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              접속방법:
                            </small>
                            <p className="small text-muted mb-2">
                              사업자등록번호 + 공인인증서 로그인
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              퇴직공제 EDI시스템 → 근로내역신고
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              적용대상:
                            </small>
                            <p className="small text-muted mb-2">
                              1억원 이상 또는 30일 이상 공사
                            </p>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              신고기한:
                            </small>
                            <p className="small text-danger mb-0 fw-semibold">
                              매월 15일 (당월분)
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://www.cw.or.kr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm w-100"
                            style={{
                              borderRadius: "8px",
                              backgroundColor: "#7b1fa2",
                              color: "white",
                            }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            건설근로자공제회
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 건강보험EDI 현장가입 */}
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#fce4ec",
                        borderRadius: "16px",
                        border: "1px solid #f8bbd9",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6
                          className="fw-bold mb-3"
                          style={{ color: "#c2185b" }}
                        >
                          건강보험EDI 현장가입
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              접속방법:
                            </small>
                            <p className="small text-muted mb-2">
                              사업장 공인인증서 로그인
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              사업장관리 → 현장사업장신고 → 건설현장가입
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              적용대상:
                            </small>
                            <p className="small text-muted mb-2">
                              건강보험·연금보험·노인장기보험료 항목 있는 경우
                            </p>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              처리기한:
                            </small>
                            <p className="small text-danger mb-0 fw-semibold">
                              착공 후 14일 이내
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://edi.nhis.or.kr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm w-100"
                            style={{
                              borderRadius: "8px",
                              backgroundColor: "#c2185b",
                              color: "white",
                            }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            건강보험EDI
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 차세대클린페이 */}
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#e0f2f1",
                        borderRadius: "16px",
                        border: "1px solid #b2dfdb",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6
                          className="fw-bold mb-3"
                          style={{ color: "#00695c" }}
                        >
                          차세대클린페이
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              접속방법:
                            </small>
                            <p className="small text-muted mb-2">
                              발주처에서 제공하는 ID/PW로 로그인
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              대금지급관리 → 현장등록
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              적용대상:
                            </small>
                            <p className="small text-muted mb-2">
                              1억원 이상 공사 또는 발주처 요청시
                            </p>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              목적:
                            </small>
                            <p className="small text-muted mb-0">
                              대금지급 투명성 확보 및 체불 방지
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://cleanpay.co.kr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm w-100"
                            style={{
                              borderRadius: "8px",
                              backgroundColor: "#00695c",
                              color: "white",
                            }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            차세대클린페이
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* 계약서류 전용 가이드 영역 - 다운로드 버튼 하단 */}
            {props.selectedItemId === "start-4" && (
              <div className="mb-4 mt-4">
                <h5 className="fw-bold mb-4 text-center text-dark">
                  📋 계약서류 업무 가이드
                </h5>

                <div className="row g-4">
                  {/* 나라장터 보증신청 카드 */}
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#e3f2fd",
                        borderRadius: "16px",
                        border: "1px solid #bbdefb",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6 className="fw-bold mb-3 text-primary">
                          나라장터 - 보증신청 (1단계)
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              접속방법:
                            </small>
                            <p className="small text-muted mb-2">
                              공인인증서 또는 간편인증 로그인
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              계약관리 → 보증 → 보증신청
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              처리절차:
                            </small>
                            <ol className="small text-muted mb-2 ps-3">
                              <li>계약정보 입력</li>
                              <li>보증종류 선택</li>
                              <li>보증기관 선택</li>
                              <li>신청서 제출</li>
                            </ol>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              필요정보:
                            </small>
                            <p className="small text-muted mb-0">
                              계약서, 사업자등록증, 건설업등록증
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://www.g2b.go.kr"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary btn-sm w-100"
                            style={{ borderRadius: "8px" }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            나라장터 바로가기
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 전문건설공제조합 카드 */}
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#fff3e0",
                        borderRadius: "16px",
                        border: "1px solid #ffcc80",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6 className="fw-bold mb-3 text-warning">
                          전문건설공제조합 - 보증서 발급 (2단계)
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              접속방법:
                            </small>
                            <p className="small text-muted mb-2">
                              조합원 로그인 (사업자등록번호 + 비밀번호)
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              보증업무 → 보증서신청 → 계약보증
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              처리절차:
                            </small>
                            <ol className="small text-muted mb-2 ps-3">
                              <li>보증신청번호 입력</li>
                              <li>보증내용 확인</li>
                              <li>서류 업로드</li>
                              <li>보증료 결제</li>
                              <li>보증서 발급</li>
                            </ol>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              적용기준:
                            </small>
                            <p className="small text-muted mb-0">
                              5천만원 이상 - 보증서
                              <br />
                              5천만원 미만 - 각서
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://www.kfinco.co.kr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-warning btn-sm w-100"
                            style={{ borderRadius: "8px" }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            전문건설공제조합
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 사업개시신고 카드 */}
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#e8f5e8",
                        borderRadius: "16px",
                        border: "1px solid #a5d6a7",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6 className="fw-bold mb-3 text-success">
                          사업개시신고 - ⚠️ 착공 전 필수 신고
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              접속방법:
                            </small>
                            <p className="small text-muted mb-2">
                              사업자등록번호로 로그인 (회원가입 불필요)
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              사업장관리 → 사업개시신고
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              처리절차:
                            </small>
                            <ol className="small text-muted mb-2 ps-3">
                              <li>사업장 기본정보 입력</li>
                              <li>공사정보 입력</li>
                              <li>근로자 수 및 업종 선택</li>
                              <li>신고서 제출</li>
                            </ol>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              필요정보:
                            </small>
                            <p className="small text-muted mb-2">
                              건설공사 계약서, 사업자등록증
                            </p>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              주의사항:
                            </small>
                            <p className="small text-danger mb-0 fw-semibold">
                              ⚠️ 착공 전에 반드시 완료
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://total.comwel.or.kr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-success btn-sm w-100"
                            style={{ borderRadius: "8px" }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            고용산재토탈서비스
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* 준공계서류 전용 가이드 영역 - 다운로드 버튼 하단 */}
            {props.selectedItemId === "completion-2-1" && (
              <div className="mb-4 mt-4">
                <h5 className="fw-bold mb-4 text-center text-dark">
                  🏁 준공계서류 업무 가이드
                </h5>

                <div className="row g-4">
                  {/* 고용산재완납증명서 */}
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#e3f2fd",
                        borderRadius: "16px",
                        border: "1px solid #bbdefb",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6 className="fw-bold mb-3 text-primary">
                          고용산재완납증명서
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              증명서발급 → 완납증명서 → 고용산재완납증명서
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              처리절차:
                            </small>
                            <ol className="small text-muted mb-2 ps-3">
                              <li>현장 선택</li>
                              <li>증명서 발급기간 선택</li>
                              <li>완납 확인 후 발급</li>
                            </ol>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              주의사항:
                            </small>
                            <p className="small text-muted mb-0">
                              모든 보험료 납부 완료 후 발급 가능
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://total.comwel.or.kr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary btn-sm w-100"
                            style={{ borderRadius: "8px" }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            고용산재토탈서비스
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 세금계산서 발급 */}
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#fff3e0",
                        borderRadius: "16px",
                        border: "1px solid #ffcc80",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6 className="fw-bold mb-3 text-warning">
                          세금계산서 발급
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              접속방법:
                            </small>
                            <p className="small text-muted mb-2">
                              사업자 공인인증서 로그인
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              조회/발급 → 전자세금계산서 → 발급
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              품목:
                            </small>
                            <p className="small text-muted mb-2">
                              안전관리비, 산업안전관리비, 환경보존비 등
                            </p>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              필요서류:
                            </small>
                            <p className="small text-muted mb-0">
                              각종 관리비 사용내역서, 영수증
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://www.hometax.go.kr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-warning btn-sm w-100"
                            style={{ borderRadius: "8px" }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            홈택스
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 회사 근로자 사대보험증명서 */}
                  <div className="col-md-4">
                    <div
                      className="card border-0 h-100 d-flex"
                      style={{
                        backgroundColor: "#e8f5e8",
                        borderRadius: "16px",
                        border: "1px solid #a5d6a7",
                      }}
                    >
                      <div className="card-body p-4 d-flex flex-column">
                        <h6 className="fw-bold mb-3 text-success">
                          회사 근로자 사대보험증명서
                        </h6>

                        <div className="flex-grow-1">
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              메뉴경로:
                            </small>
                            <p className="small text-muted mb-2">
                              증명서발급 → 사업장가입자명부
                            </p>
                          </div>
                          <div className="mb-3">
                            <small className="text-muted fw-semibold">
                              처리절차:
                            </small>
                            <ol className="small text-muted mb-2 ps-3">
                              <li>노무비미체불확약서 내용 확인</li>
                              <li>회사 근로자로만 구성된 공사인지 확인</li>
                              <li>해당 직원들의 사대보험가입증명서 발급</li>
                            </ol>
                          </div>
                          <div className="mb-0">
                            <small className="text-muted fw-semibold">
                              적용조건:
                            </small>
                            <p className="small text-muted mb-0">
                              노무비미체불확약서 제출 공사
                            </p>
                          </div>
                        </div>

                        <div className="mt-auto pt-3">
                          <a
                            href="https://www.4insure.or.kr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-success btn-sm w-100"
                            style={{ borderRadius: "8px" }}
                          >
                            <span
                              className="material-symbols-outlined me-1"
                              style={{ fontSize: "16px" }}
                            >
                              open_in_new
                            </span>
                            사대보험정보연계센터
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 기본정보 모달 */}
      <PresetModal
        isOpen={props.isPresetModalOpen}
        onClose={props.onClosePresetModal}
        onSave={props.onSavePreset}
        presetType={props.currentPresetType}
        editingPreset={props.editingPreset}
        presets={props.presets}
        onEditPreset={props.onEditPreset}
        onDeletePreset={props.onDeletePreset}
        defaultPresets={props.getDefaultPresetsFromStorage()}
        onSetDefaultPreset={props.onSetDefaultPreset}
        onClearDefaultPreset={props.onClearDefaultPreset}
      />
    </div>
  );
};

export default ExcelPresenter;
